
export enum LookupInternalCollection
{
	None = 'None',
	QuestionResult = 'QuestionResult',
	Gender = 'Gender',
	Salutation = 'Salutation',
	MaritalStatus = 'MaritalStatus',
	EmploymentStatus = 'EmploymentStatus',
	CorrespondFlags = 'CorrespondFlags',
	TransactionMethod = 'TransactionMethod',
	SecurityRights = 'SecurityRights',
	TimePeriod = 'TimePeriod',
	InsertField = 'InsertField',
	TextFormat = 'TextFormat',
	SystemEventType = 'SystemEventType',
	SystemEventCategory = 'SystemEventCategory',
	ExtensionType = 'ExtensionType',
	DataBackupMode = 'DataBackupMode',
	ImageBackupMode = 'ImageBackupMode',
	SchedulePeriod = 'SchedulePeriod',
	ImageResize = 'ImageResize',
	ReportSpecType = 'ReportSpecType',
	ReportSpecFunction = 'ReportSpecFunction',
	SecurityScopeFinance = 'SecurityScopeFinance',
	EntityType = 'EntityType',
	FieldType = 'FieldType',
	MarketingListConditionType = 'MarketingListConditionType',
	MarketingEventFlagsType = 'MarketingEventFlagsType',
	SecurityScopeLockAccess = 'SecurityScopeLockAccess',
	RateMethod = 'RateMethod',
	DocumentCategory = 'DocumentCategory',
	SystemStatCategory = 'SystemStatCategory',
	SystemStatSubCategory = 'SystemStatSubCategory',
	CustomScriptType = 'CustomScriptType',
	ContactView = 'ContactView',
	VehicleView = 'VehicleView',
	SaleView = 'SaleView',
	OpportunityView = 'OpportunityView',
	VehicleClass = 'VehicleClass',
	VehicleManufacturer = 'VehicleManufacturer',
	VehicleTransmissionType = 'VehicleTransmissionType',
	VehicleBodyStyle = 'VehicleBodyStyle',
	VehicleWheelComposition = 'VehicleWheelComposition',
	VehicleTyreCondition = 'VehicleTyreCondition',
	VehicleInteriorTrim = 'VehicleInteriorTrim',
	VehicleSeatMaterial = 'VehicleSeatMaterial',
	VehicleEngineSizeUnit = 'VehicleEngineSizeUnit',
	VehicleEngineType = 'VehicleEngineType',
	VehicleFuelType = 'VehicleFuelType',
	VehicleOdometerUnit = 'VehicleOdometerUnit',
	VehicleDriveSystem = 'VehicleDriveSystem',
	VehicleStatus = 'VehicleStatus',
	VehiclePurchaseType = 'VehiclePurchaseType',
	VehiclePrevOwnerType = 'VehiclePrevOwnerType',
	VehicleOdometerStatus = 'VehicleOdometerStatus',
	VehicleExpenseType = 'VehicleExpenseType',
	VehicleExpenseTypeCategory = 'VehicleExpenseTypeCategory',
	VehicleExpenseSaleOrderMode = 'VehicleExpenseSaleOrderMode',
	VehicleGroupBy = 'VehicleGroupBy',
	VehicleOrderBy = 'VehicleOrderBy',
	VehicleAttributeType = 'VehicleAttributeType',
	VehicleExpenseGroupBy = 'VehicleExpenseGroupBy',
	VehicleExpensePriceMode = 'VehicleExpensePriceMode',
	VehicleLockdownCondition = 'VehicleLockdownCondition',
	VehicleExpensePaymentStatus = 'VehicleExpensePaymentStatus',
	VehicleConstructionType = 'VehicleConstructionType',
	VehicleStandardFeatures = 'VehicleStandardFeatures',
	VehicleTurboType = 'VehicleTurboType',
	VehicleSoldState = 'VehicleSoldState',
	VehicleSearchField = 'VehicleSearchField',
	TenancyType = 'TenancyType',
	ProductClass = 'ProductClass',
	ProductSubClass = 'ProductSubClass',
	ContactType = 'ContactType',
	OpportunitySearchField = 'OpportunitySearchField',
	NotificationGroup = 'NotificationGroup',
	NotificationContentType = 'NotificationContentType',
	ExportSpecProvider = 'ExportSpecProvider',
	ExportPersistType = 'ExportPersistType',
	ExportFormatType = 'ExportFormatType',
	ExportDataFilter = 'ExportDataFilter',
	ExportVehicleField = 'ExportVehicleField',
	ExportVehicleAction = 'ExportVehicleAction',
	ExportVehicleDuration = 'ExportVehicleDuration',
	ExportDescInsertPosition = 'ExportDescInsertPosition',
	ExportBestContactTime = 'ExportBestContactTime',
	ExportColumnNamesTransformMode = 'ExportColumnNamesTransformMode',
	VehicleExpenseDuplicateDetectionMethod = 'VehicleExpenseDuplicateDetectionMethod',
	VehicleAgeingMethod = 'VehicleAgeingMethod',
	VehicleTradeDefaultAppraiser = 'VehicleTradeDefaultAppraiser',
	SaleGroupBy = 'SaleGroupBy',
	SaleOrderBy = 'SaleOrderBy',
	SaleLockdownCondition = 'SaleLockdownCondition',
	SaleStatus = 'SaleStatus',
	SaleType = 'SaleType',
	InProgressSale = 'InProgressSale',
	SaleMoneyOutValue = 'SaleMoneyOutValue',
	SaleDeliveryStatus = 'SaleDeliveryStatus',
	TaskType = 'TaskType',
	TaskPriority = 'TaskPriority',
	TaskStatus = 'TaskStatus',
	TaskReminderPeriod = 'TaskReminderPeriod',
	TaskDueDate = 'TaskDueDate',
	TaskCompletedDate = 'TaskCompletedDate',
	TaskPlanAction = 'TaskPlanAction',
	TaskPlanTimeRelation = 'TaskPlanTimeRelation',
	TaskPlanTimePeriod = 'TaskPlanTimePeriod',
	TaskPlanReferenceDate = 'TaskPlanReferenceDate',
	TaskCreationPastRule = 'TaskCreationPastRule',
	TaskCompletionAutoMethod = 'TaskCompletionAutoMethod',
	TaskPlanAssigneeRole = 'TaskPlanAssigneeRole',
	TaskClass = 'TaskClass',
	TaskGroupBy = 'TaskGroupBy',
	TaskOrderBy = 'TaskOrderBy',
	AdvertEditTemplate = 'AdvertEditTemplate',
	AdvertPrintTemplate = 'AdvertPrintTemplate',
	OpportunityStatus = 'OpportunityStatus',
	OpportunityProbability = 'OpportunityProbability',
	OpportunityOrigin = 'OpportunityOrigin',
	OpportunityActivityType = 'OpportunityActivityType',
	OpportunityAssignmentScheme = 'OpportunityAssignmentScheme',
	SaleInvoiceStatus = 'SaleInvoiceStatus',
	PurchaseOrderStatus = 'PurchaseOrderStatus',
	PurchaseOrderInvoicedStatus = 'PurchaseOrderInvoicedStatus',
	StatementCreationMode = 'StatementCreationMode',
	VehicleTradeExportMode = 'VehicleTradeExportMode',
	PurchaseInvoicesDueDate = 'PurchaseInvoicesDueDate',
	AccountingExportSegmentation = 'AccountingExportSegmentation',
	ImportVehicleProcessingMode = 'ImportVehicleProcessingMode',
	MiscGroupBy = 'MiscGroupBy',
	SaleAgreementInsuranceDisplayMode = 'SaleAgreementInsuranceDisplayMode',
	PurchaseOrderSearchField = 'PurchaseOrderSearchField',
	FinanceFeeExportMode = 'FinanceFeeExportMode',
	PurchaseInvoicesSplitMode = 'PurchaseInvoicesSplitMode',
	WorkflowStatus = 'WorkflowStatus',
	WorkflowAction = 'WorkflowAction',
	ImportVehicleImageProcessingMode = 'ImportVehicleImageProcessingMode',
	DriverLicenceType = 'DriverLicenceType',
	EmploymentPermanence = 'EmploymentPermanence',
	ResidencyStatus = 'ResidencyStatus',
	GoogleAdTemplateSize = 'GoogleAdTemplateSize',
	PartAllocationTransactions = 'PartAllocationTransactions',
	AdvertSettingMode = 'AdvertSettingMode',
	AdvertActionType = 'AdvertActionType',
	AdvertConfigSettings = 'AdvertConfigSettings',
	AdvertAnalysisPeriod = 'AdvertAnalysisPeriod',
	VehicleAdvertTranGroupBy = 'VehicleAdvertTranGroupBy',
	VehicleAdvertTranOrderBy = 'VehicleAdvertTranOrderBy',
	ContactEmailValidationMode = 'ContactEmailValidationMode',
	ProductPaymentType = 'ProductPaymentType',
	FinanceSecurityType = 'FinanceSecurityType',
	DeliveryLocation = 'DeliveryLocation',
	AdvertFeatureFlags = 'AdvertFeatureFlags',
	ContactOrderBy = 'ContactOrderBy',
    CustomerKeyInfo = 'CustomerKeyInfo',
    VehicleKeyInfo = 'VehicleKeyInfo',
}

export enum LookupExternalCollection
{
	/// <summary>None</summary>
	None = 'None',

	/// <summary>ReferralMethod</summary>
	ReferralMethod = 'ReferralMethod',
	/// <summary>Campaign</summary>
	Campaign = 'Campaign',
	/// <summary>LocationCity</summary>
	LocationCity = 'LocationCity',
	/// <summary>MarketingList</summary>
	MarketingList = 'MarketingList',
	/// <summary>MarketingListCondition</summary>
	MarketingListCondition = 'MarketingListCondition',

	/// <summary>VehicleColorExterior</summary>
	VehicleColorExterior = 'VehicleColorExterior',
	/// <summary>VehicleColorInterior</summary>
	VehicleColorInterior = 'VehicleColorInterior',
	/// <summary>VehicleManufacturer</summary>
	VehicleManufacturer = 'VehicleManufacturer',
	/// <summary>VehicleModel</summary>
	VehicleModel = 'VehicleModel',
	/// <summary>VehicleVariant</summary>
	VehicleVariant = 'VehicleVariant',
	/// <summary>VehicleTransmission</summary>
	VehicleTransmission = 'VehicleTransmission',
	/// <summary>VehicleBodyStyle</summary>
	VehicleBodyStyle = 'VehicleBodyStyle',
	/// <summary>VehicleSunroof</summary>
	VehicleSunroof = 'VehicleSunroof',
	/// <summary>VehicleWheelComposition</summary>
	VehicleWheelComposition = 'VehicleWheelComposition',
	/// <summary>VehicleTyreCondition</summary>
	VehicleTyreCondition = 'VehicleTyreCondition',
	/// <summary>VehicleInteriorTrim</summary>
	VehicleInteriorTrim = 'VehicleInteriorTrim',
	/// <summary>VehicleSeatMaterial</summary>
	VehicleSeatMaterial = 'VehicleSeatMaterial',
	/// <summary>VehicleEngineType</summary>
	VehicleEngineType = 'VehicleEngineType',
	/// <summary>VehicleFuelType</summary>
	VehicleFuelType = 'VehicleFuelType',
	/// <summary>VehicleTurbo</summary>
	VehicleTurbo = 'VehicleTurbo',
	/// <summary>VehicleDriveSystem</summary>
	VehicleDriveSystem = 'VehicleDriveSystem',
	/// <summary>VehicleExteriorFeatures</summary>
	VehicleExteriorFeatures = 'VehicleExteriorFeatures',
	/// <summary>VehicleInteriorFeatures</summary>
	VehicleInteriorFeatures = 'VehicleInteriorFeatures',
	/// <summary>VehicleMechanicalFeatures</summary>
	VehicleMechanicalFeatures = 'VehicleMechanicalFeatures',
	/// <summary>VehicleDeliveryPort</summary>
	VehicleDeliveryPort = 'VehicleDeliveryPort',
	/// <summary>VehicleEngineManufacturer</summary>
	VehicleEngineManufacturer = 'VehicleEngineManufacturer',
	/// <summary>VehicleTransmissionManufacturer</summary>
	VehicleTransmissionManufacturer = 'VehicleTransmissionManufacturer',
	/// <summary>VehicleExportText</summary>
	VehicleExportText = 'VehicleExportText',
	/// <summary>VehicleConstructionType</summary>
	VehicleConstructionType = 'VehicleConstructionType',
	/// <summary>VehicleOfferText</summary>
	VehicleOfferText = 'VehicleOfferText',
	/// <summary>VehicleGroups</summary>
	VehicleGroups = 'VehicleGroups',
	/// <summary>VehicleAdvertText</summary>
	VehicleAdvertText = 'VehicleAdvertText',
	/// <summary>VehiclePoster</summary>
	VehiclePoster = 'VehiclePoster',
	/// <summary>VehicleFuelSaverText</summary>
	VehicleFuelSaverText = 'VehicleFuelSaverText',
	/// <summary>VehicleExpenseCategories</summary>
	VehicleExpenseCategories = 'VehicleExpenseCategories',
    /// <summary>VehicleSmsTextLibrary</summary>
    VehicleSmsTextLibrary = 'VehicleSmsTextLibrary',

	/// <summary>SystemSettings</summary>
	SystemSettings = 'SystemSettings',
	/// <summary>CustomFields</summary>
	CustomFields = 'CustomFields',
	/// <summary>ContactGroups</summary>
	ContactGroups = 'ContactGroups',
	/// <summary>CustomScripts</summary>
	CustomScripts = 'CustomScripts',
	/// <summary>DeliveryRates</summary>
	DeliveryRates = 'DeliveryRates',
	/// <summary>UserRoles</summary>
	UserRoles = 'UserRoles',

	/// <summary>TaskColor</summary>
	TaskColor = 'TaskColor',

	/// <summary>OpportunityReasonsWon</summary>
	OpportunityReasonsWon = 'OpportunityReasonsWon',
	/// <summary>OpportunityReasonsLost</summary>
	OpportunityReasonsLost = 'OpportunityReasonsLost',
	/// <summary>OpportunityReasonsOpen</summary>
	OpportunityReasonsOpen = 'OpportunityReasonsOpen',
	/// <summary>OpportunityNextAction</summary>
	OpportunityNextAction = 'OpportunityNextAction',

	/// <summary>AccExportCategory</summary>
	AccExportCategory = 'AccExportCategory',

	/// <summary>SaleDeliveryItems</summary>
	SaleDeliveryItems = 'SaleDeliveryItems',
	/// <summary>SaleSpecialConditions</summary>
	SaleSpecialConditions = 'SaleSpecialConditions',

	/// <summary>SetImportCalculator</summary>
	SetImportCalculator = 'SetImportCalculator',
}

export enum LookupExtImageCollection
{
	None = 'None',
	ImageOverlay = 'ImageOverlay',
}


export enum SalesStatus
{
	All = 'All',
	None = 'None',
	Prospect = 'Prospect',
	VehiclePurchase = 'VehiclePurchase',
	Reconditioning = 'Reconditioning',
	Finance = 'Finance',
	Insurance = 'Insurance',
	SaleExtras = 'SaleExtras',
	IncludeGroups = 'IncludeGroups',
	AcceptWebOpport = 'AcceptWebOpport',
	HasServiceDepartment = 'HasServiceDepartment'
}

export enum ContactType
{
	All = 'All',
	User = 'User',
	Customer = 'Customer',
	Supplier = 'Supplier',
	Employer = 'Employer'
}

export enum ContactClass
{
	All = 'All',
	Business = 'Company',
	Individual = 'Individual'
}


export enum VehicleClass
{
	All = 'All',
	None = 'None',
	PassengerVehicle = 'PassengerVehicle',
	GoodsVehicle = 'GoodsVehicle',
	Motorcycle = 'Motorcycle',
	Boat = 'Boat',
	Bus = 'Bus',
	Caravan = 'Caravan',
	Machine = 'Machine',
	Motorhome = 'Motorhome',
}

export enum VehicleExpenseType
{
	StandardExpense = 'StandardExpense',
	AfterSaleExpense = 'AfterSaleExpense',

	ImportVehicleCost = 'ImportVehicleCost',
	ImportAgentFee = 'ImportAgentFee',
	ImportFreight = 'ImportFreight',
	ImportOther = 'ImportOther',
	ImportTax = 'ImportTax',

	LocalVehicleCost = 'LocalVehicleCost',
	LocalAgentFee = 'LocalAgentFee',
	LocalFreight = 'LocalFreight',
	LocalOther = 'LocalOther',
	LocalPortServices = 'LocalPortServices',
	LocalCustomEntry = 'LocalCustomEntry',
}

export enum TaxStatusEnum
{
	None = 'None',
	Inclusive = 'Inclusive',
	Exclusive = 'Exclusive',
	Zero = 'Zero',
	Exempt = 'Exempt',
	NotRegistered = 'NotRegistered',
	OverrideInclusive = 'OverrideInclusive',
	OverrideExclusive = 'OverrideExclusive',
	TaxAmount = 'TaxAmount',
	POA = 'POA',
	Auction = 'Auction',
	Tender = 'Tender',
}

export enum TimePeriod
{
	Day = 'Day',
	Week = 'Week',
	Fortnight = 'Fortnight',
	Month = 'Month',
	Year = 'Year'
}

export enum SecurityRight
{
	Admin = 'Admin',
	AdminUserMan = 'AdminUserMan',
	AdminCurrency = 'AdminCurrency',
	AdminCurrencyMan = 'AdminCurrencyMan',
	AdminCurrencyFX = 'AdminCurrencyFX',
	AdminDealershipMan = 'AdminDealershipMan',
	AdminLookupMan = 'AdminLookupMan',
	AdminAppSettings = 'AdminAppSettings',
	AdminCountryMan = 'AdminCountryMan',
	AdminCityMan = 'AdminCityMan',
	AdminPartMan = 'AdminPartMan',
	AdminProductMan = 'AdminProductMan',
	AdminVehicleTemplateMan = 'AdminVehicleTemplateMan',
	AdminImageOverlayMan = 'AdminImageOverlayMan',
	AdminVehiclePosterMan = 'AdminVehiclePosterMan',
	AdminLetterMan = 'AdminLetterMan',
	AdminEmailMan = 'AdminEmailMan',
	AdminExtensionMan = 'AdminExtensionMan',
	AdminReportMan = 'AdminReportMan',
	AdminAdvertSpecMan = 'AdminAdvertSpecMan',
    AdminWebsiteMan = 'AdminWebsiteMan',

	Vehicles = 'Vehicles',
	VehiclesFunctions = 'VehiclesFunctions',
	VehiclesFunctionsCreate = 'VehiclesFunctionsCreate',
	VehiclesFunctionsDelete = 'VehiclesFunctionsDelete',
	VehiclesFunctionsTransfer = 'VehiclesFunctionsTransfer',
	VehiclesFunctionsAddMakeModelVariant = 'VehiclesFunctionsAddMakeModelVariant',
	VehiclesFunctionsAddOtherLookups = 'VehiclesFunctionsAddOtherLookups',
	VehiclesFunctionsEditStockNo = 'VehiclesFunctionsEditStockNo',
	VehiclesFunctionsInsights = 'VehiclesFunctionsInsights',
	VehiclesFunctionsInsightsView = 'VehiclesFunctionsInsightsView',
	VehiclesFunctionsInsightsEdit = 'VehiclesFunctionsInsightsEdit',
	VehiclesFunctionsAccessPurchaseCosts = 'VehiclesFunctionsAccessPurchaseCosts',

	VehiclesTabs = 'VehiclesTabs',
	VehiclesTabsGeneral = 'VehiclesTabsGeneral',
	VehiclesTabsGeneralView = 'VehiclesTabsGeneralView',
	VehiclesTabsGeneralEdit = 'VehiclesTabsGeneralEdit',
	VehiclesTabsPurchase = 'VehiclesTabsPurchase',
	VehiclesTabsPurchaseView = 'VehiclesTabsPurchaseView',
	VehiclesTabsPurchaseEdit = 'VehiclesTabsPurchaseEdit',
	VehiclesTabsExpenses = 'VehiclesTabsExpenses',
	VehiclesTabsExpensesView = 'VehiclesTabsExpensesView',
	VehiclesTabsExpensesEdit = 'VehiclesTabsExpensesEdit',
	VehiclesTabsExterior = 'VehiclesTabsExterior',
	VehiclesTabsExteriorView = 'VehiclesTabsExteriorView',
	VehiclesTabsExteriorEdit = 'VehiclesTabsExteriorEdit',
	VehiclesTabsInterior = 'VehiclesTabsInterior',
	VehiclesTabsInteriorView = 'VehiclesTabsInteriorView',
	VehiclesTabsInteriorEdit = 'VehiclesTabsInteriorEdit',
	VehiclesTabsMechanical = 'VehiclesTabsMechanical',
	VehiclesTabsMechanicalView = 'VehiclesTabsMechanicalView',
	VehiclesTabsMechanicalEdit = 'VehiclesTabsMechanicalEdit',
	VehiclesTabsExport = 'VehiclesTabsExport',
	VehiclesTabsExportView = 'VehiclesTabsExportView',
	VehiclesTabsExportEdit = 'VehiclesTabsExportEdit',
	VehiclesTabsImages = 'VehiclesTabsImages',
	VehiclesTabsImagesView = 'VehiclesTabsImagesView',
	VehiclesTabsImagesEdit = 'VehiclesTabsImagesEdit',
	VehiclesTabsAdmin = 'VehiclesTabsAdmin',
	VehiclesTabsAdminView = 'VehiclesTabsAdminView',
	VehiclesTabsAdminEdit = 'VehiclesTabsAdminEdit',
	VehiclesTabsCustom = 'VehiclesTabsCustom',
	VehiclesTabsCustomView = 'VehiclesTabsCustomView',
	VehiclesTabsCustomEdit = 'VehiclesTabsCustomEdit',


	Opport = 'Opport',
	OpportFunctions = 'OpportFunctions',
	OpportFunctionsCreateQuote = 'OpportFunctionsCreateQuote',
	OpportFunctionsCreateFinanceApp = 'OpportFunctionsCreateFinanceApp',
	OpportFunctionsCreateTestDrive = 'OpportFunctionsCreateTestDrive',
    OpportFunctionsCreateLoanVehicle = 'OpportFunctionsCreateLoanVehicle',
	OpportFunctionsCreatePriceMyTrade = 'OpportFunctionsCreatePriceMyTrade',
	OpportFunctionsCreateOther = 'OpportFunctionsCreateOther',
	OpportFunctionsDeleteQuote = 'OpportFunctionsDeleteQuote',
	OpportFunctionsDeleteFinanceApp = 'OpportFunctionsDeleteFinanceApp',
	OpportFunctionsDeleteTestDrive = 'OpportFunctionsDeleteTestDrive',
    OpportFunctionsDeleteLoanVehicle = 'OpportFunctionsDeleteLoanVehicle',
	OpportFunctionsDeletePriceMyTrade = 'OpportFunctionsDeletePriceMyTrade',
	OpportFunctionsDeleteOther = 'OpportFunctionsDeleteOther',
	OpportTabs = 'OpportTabs',
	OpportTabsOpportunityGeneral = 'OpportTabsOpportunityGeneral',
	OpportTabsOpportunityGeneralView = 'OpportTabsOpportunityGeneralView',
	OpportTabsOpportunityGeneralEdit = 'OpportTabsOpportunityGeneralEdit',
	OpportTabsOpportunityCustom = 'OpportTabsOpportunityCustom',
	OpportTabsOpportunityCustomView = 'OpportTabsOpportunityCustomView',
	OpportTabsOpportunityCustomEdit = 'OpportTabsOpportunityCustomEdit',
	OpportTabsQuoteGeneral = 'OpportTabsQuoteGeneral',
	OpportTabsQuoteGeneralView = 'OpportTabsQuoteGeneralView',
	OpportTabsQuoteGeneralEdit = 'OpportTabsQuoteGeneralEdit',
	OpportTabsQuoteFinance = 'OpportTabsQuoteFinance',
	OpportTabsQuoteFinanceView = 'OpportTabsQuoteFinanceView',
	OpportTabsQuoteFinanceEdit = 'OpportTabsQuoteFinanceEdit',
	OpportTabsFinanceAppGeneral = 'OpportTabsFinanceAppGeneral',
	OpportTabsFinanceAppGeneralView = 'OpportTabsFinanceAppGeneralView',
	OpportTabsFinanceAppGeneralEdit = 'OpportTabsFinanceAppGeneralEdit',
	OpportTabsFinanceAppFinance = 'OpportTabsFinanceAppFinance',
	OpportTabsFinanceAppFinanceView = 'OpportTabsFinanceAppFinanceView',
	OpportTabsFinanceAppFinanceEdit = 'OpportTabsFinanceAppFinanceEdit',
	OpportTabsTestDriveGeneral = 'OpportTabsTestDriveGeneral',
	OpportTabsTestDriveGeneralView = 'OpportTabsTestDriveGeneralView',
	OpportTabsTestDriveGeneralEdit = 'OpportTabsTestDriveGeneralEdit',
    OpportTabsLoanVehicleGeneral = 'OpportTabsLoanVehicleGeneral',
    OpportTabsLoanVehicleGeneralView = 'OpportTabsLoanVehicleGeneralView',
    OpportTabsLoanVehicleGeneralEdit = 'OpportTabsLoanVehicleGeneralEdit',
	OpportTabsPriceMyTradeGeneral = 'OpportTabsPriceMyTradeGeneral',
	OpportTabsPriceMyTradeGeneralView = 'OpportTabsPriceMyTradeGeneralView',
	OpportTabsPriceMyTradeGeneralEdit = 'OpportTabsPriceMyTradeGeneralEdit',
	OpportTabsOtherGeneral = 'OpportTabsOtherGeneral',
	OpportTabsOtherGeneralView = 'OpportTabsOtherGeneralView',
	OpportTabsOtherGeneralEdit = 'OpportTabsOtherGeneralEdit',

	Contact = 'Contact',
	ContactFunctions = 'ContactFunctions',
	ContactFunctionsCreate = 'ContactFunctionsCreate',
	ContactFunctionsDelete = 'ContactFunctionsDelete',
	ContactTabs = 'ContactTabs',
	ContactTabsGeneral = 'ContactTabsGeneral',
	ContactTabsGeneralView = 'ContactTabsGeneralView',
	ContactTabsGeneralEdit = 'ContactTabsGeneralEdit',
	ContactTabsAddresses = 'ContactTabsAddresses',
	ContactTabsAddressesView = 'ContactTabsAddressesView',
	ContactTabsAddressesEdit = 'ContactTabsAddressesEdit',
	ContactTabsAdmin = 'ContactTabsAdmin',
	ContactTabsAdminView = 'ContactTabsAdminView',
	ContactTabsAdminEdit = 'ContactTabsAdminEdit',
	ContactTabsSales = 'ContactTabsSales',
	ContactTabsSalesView = 'ContactTabsSalesView',
	ContactTabsSalesEdit = 'ContactTabsSalesEdit',
	ContactTabsVehicles = 'ContactTabsVehicles',
	ContactTabsVehiclesView = 'ContactTabsVehiclesView',
	ContactTabsVehiclesEdit = 'ContactTabsVehiclesEdit',

	Sale = 'Sale',
	SaleFunctions = 'SaleFunctions',
	SaleFunctionsSummary = 'SaleFunctionsSummary',
	SaleFunctionsSettings = 'SaleFunctionsSettings',
	SaleFunctionsWorkflow = 'SaleFunctionsWorkflow',
	SaleFunctionsCreate = 'SaleFunctionsCreate',
	SaleFunctionsDelete = 'SaleFunctionsDelete',
	SaleFunctionsEditSaleNo = 'SaleFunctionsEditSaleNo',
	SaleFunctionsSearch = 'SaleFunctionsSearch',
	SaleTabs = 'SaleTabs',
	SaleTabsGeneral = 'SaleTabsGeneral',
	SaleTabsGeneralView = 'SaleTabsGeneralView',
	SaleTabsGeneralEdit = 'SaleTabsGeneralEdit',
	SaleTabsVehicles = 'SaleTabsVehicles',
	SaleTabsVehiclesView = 'SaleTabsVehiclesView',
	SaleTabsVehiclesEdit = 'SaleTabsVehiclesEdit',
	SaleTabsExtras = 'SaleTabsExtras',
	SaleTabsExtrasView = 'SaleTabsExtrasView',
	SaleTabsExtrasEdit = 'SaleTabsExtrasEdit',
	SaleTabsPayments = 'SaleTabsPayments',
	SaleTabsPaymentsView = 'SaleTabsPaymentsView',
	SaleTabsPaymentsEdit = 'SaleTabsPaymentsEdit',
	SaleTabsWriteback = 'SaleTabsWriteback',
	SaleTabsWritebackView = 'SaleTabsWritebackView',
	SaleTabsWritebackEdit = 'SaleTabsWritebackEdit',
	SaleTabsNotes = 'SaleTabsNotes',
	SaleTabsNotesView = 'SaleTabsNotesView',
	SaleTabsNotesEdit = 'SaleTabsNotesEdit',
	SaleTabsCustom = 'SaleTabsCustom',
	SaleTabsCustomView = 'SaleTabsCustomView',
	SaleTabsCustomEdit = 'SaleTabsCustomEdit',
	SaleTabsFinance = 'SaleTabsFinance',
	SaleTabsFinanceView = 'SaleTabsFinanceView',
	SaleTabsFinanceEdit = 'SaleTabsFinanceEdit',
	SaleTabsFooter = 'SaleTabsFooter',
	SaleTabsFooterView = 'SaleTabsFooterView',
	SaleTabsFooterEdit = 'SaleTabsFooterEdit',

	CRM = 'CRM',
	CRMAdverts = 'CRMAdverts',
	CRMAdvertsFunctions = 'CRMAdvertsFunctions',
	CRMAdvertsFunctionsCreate = 'CRMAdvertsFunctionsCreate',
	CRMAdvertsFunctionsPrint = 'CRMAdvertsFunctionsPrint',
	CRMAdvertsTabs = 'CRMAdvertsTabs',
	CRMAdvertsTabsBasics = 'CRMAdvertsTabsBasics',
	CRMAdvertsTabsBasicsView = 'CRMAdvertsTabsBasicsView',
	CRMAdvertsTabsBasicsEdit = 'CRMAdvertsTabsBasicsEdit',

	Accounting = 'Accounting',
	AccountingRunExport = 'AccountingRunExport',
	AccountingSaleInvoices = 'AccountingSaleInvoices',
	AccountingPurchaseOrders = 'AccountingPurchaseOrders',
	AccountingPurchaseOrdersFunctions = 'AccountingPurchaseOrdersFunctions',
	AccountingPurchaseOrdersFunctionsCreate = 'AccountingPurchaseOrdersFunctionsCreate',
	AccountingPurchaseOrdersFunctionsPrint = 'AccountingPurchaseOrdersFunctionsPrint',
	AccountingPurchaseOrdersFunctionsApprove = 'AccountingPurchaseOrdersFunctionsApprove',
	AccountingPurchaseOrdersFunctionsCancel = 'AccountingPurchaseOrdersFunctionsCancel',
	AccountingPurchaseOrdersTabs = 'AccountingPurchaseOrdersTabs',
	AccountingPurchaseOrdersTabsBasics = 'AccountingPurchaseOrdersTabsBasics',
	AccountingPurchaseOrdersTabsBasicsView = 'AccountingPurchaseOrdersTabsBasicsView',
	AccountingPurchaseOrdersTabsBasicsEdit = 'AccountingPurchaseOrdersTabsBasicsEdit',
	AccountingPurchaseInvoices = 'AccountingPurchaseInvoices',

	Export = 'Export',

	Reports = 'Reports',
	ReportsStock = 'ReportsStock',
	ReportsSales = 'ReportsSales',
	ReportsPurchases = 'ReportsPurchases',
	ReportsFinancials = 'ReportsFinancials',
	ReportsAdmin = 'ReportsAdmin',
	ReportsCustom = 'ReportsCustom',
	ReportsOther = 'ReportsOther',

	Tools = 'Tools',
	ToolsMoneyOutstanding = 'ToolsMoneyOutstanding',
	ToolsVehiclePurchaseCalculator = 'ToolsVehiclePurchaseCalculator',
	ToolsVehicleProfitCalculator = 'ToolsVehicleProfitCalculator',
	ToolsBulkExpenseEntry = 'ToolsBulkExpenseEntry',
	ToolsImportPurchasedVehicles = 'ToolsImportPurchasedVehicles',
	ToolsEventViewer = 'ToolsEventViewer',
	ToolsDataExport = 'ToolsDataExport',
	ToolsDataImport = 'ToolsDataImport',
	ToolsVehicleStocktakeTool = 'ToolsVehicleStocktakeTool',
    ToolsBulkUpdate = 'ToolsBulkUpdate',

	ToolsTasks = 'ToolsTasks',
	ToolsTasksTaskPlanner = 'ToolsTasksTaskPlanner',
	ToolsTasksTaskViewer = 'ToolsTasksTaskViewer',
	ToolsTasksFunctions = 'ToolsTasksFunctions',
	ToolsTasksFunctionsCreate = 'ToolsTasksFunctionsCreate',
	ToolsTasksFunctionsCreateOwn = 'ToolsTasksFunctionsCreateOwn',
	ToolsTasksFunctionsView = 'ToolsTasksFunctionsView',
	ToolsTasksFunctionsViewOwn = 'ToolsTasksFunctionsViewOwn',
	ToolsTasksFunctionsEdit = 'ToolsTasksFunctionsEdit',
	ToolsTasksFunctionsEditOwn = 'ToolsTasksFunctionsEditOwn',
	ToolsTasksFunctionsEditCompleted = 'ToolsTasksFunctionsEditCompleted',
	ToolsTasksFunctionsEditPostpone = 'ToolsTasksFunctionsEditPostpone',
	ToolsTasksFunctionsEditDelegate = 'ToolsTasksFunctionsEditDelegate',
	ToolsTasksFunctionsDelete = 'ToolsTasksFunctionsDelete',
	ToolsTasksFunctionsDeleteOwn = 'ToolsTasksFunctionsDeleteOwn',
	ToolsTasksFunctionsDeleteCompleted = 'ToolsTasksFunctionsDeleteCompleted',

	ToolsDealerzone = 'ToolsDealerzone',
	ToolsDealerzoneWholesale = 'ToolsDealerzoneWholesale',
	ToolsDealerzoneWholesaleBuying = 'ToolsDealerzoneWholesaleBuying',
	ToolsDealerzoneCarCheck = 'ToolsDealerzoneCarCheck',
	ToolsDealerzoneBuyerScore = 'ToolsDealerzoneBuyerScore',
	ToolsDealerzoneAutoAttendant = 'ToolsDealerzoneAutoAttendant',
	ToolsDealerzoneBigData = 'ToolsDealerzoneBigData',

	ToolsDocuments = 'ToolsDocuments',
	ToolsDocumentsDocumentBrowser = 'ToolsDocumentsDocumentBrowser',
	ToolsDocumentsFunctions = 'ToolsDocumentsFunctions',
	ToolsDocumentsFunctionsCreate = 'ToolsDocumentsFunctionsCreate',
	ToolsDocumentsFunctionsView = 'ToolsDocumentsFunctionsView',
	ToolsDocumentsFunctionsEdit = 'ToolsDocumentsFunctionsEdit',
	ToolsDocumentsFunctionsDelete = 'ToolsDocumentsFunctionsDelete',

	SupportUser = 'SupportUser'
}

export enum VehicleOrderBy
{
	None = 'None',
	StockNo = 'StockNo',
	StockNoDesc = 'StockNoDesc',
	RegNo = 'RegNo',
	RegNoDesc = 'RegNoDesc',
	MakeModel = 'MakeModel',
	MakeModelDesc = 'MakeModelDesc',
	RetailPrice = 'RetailPrice',
	RetailPriceDesc = 'RetailPriceDesc',
	// AgeingDate = '// AgeingDate',
	// AgeingDateDesc = '// AgeingDateDesc',
	StatusDate = 'StatusDate',
	StatusDateDesc = 'StatusDateDesc',
	Year = 'Year',
	YearDesc = 'YearDesc',
	SaleDate = 'SaleDate',
	SaleDateDesc = 'SaleDateDesc',
	CreatedDate = 'CreatedDate',
	CreatedDateDesc = 'CreatedDateDesc',
	ModifiedDate = 'ModifiedDate',
	ModifiedDateDesc = 'ModifiedDateDesc',
	OpportCount = 'OpportCount',
	OpportCountDesc = 'OpportCountDesc',
}

// Bulk update vehicle list ordering is intentionally separate from the normal vehicle list,
// so we can add bulk-specific sort options without impacting other screens.
export enum BulkUpdateVehicleOrderBy
{
	None = 'None',
	StockNo = 'StockNo',
	StockNoDesc = 'StockNoDesc',
	RegNo = 'RegNo',
	RegNoDesc = 'RegNoDesc',
	MakeModel = 'MakeModel',
	MakeModelDesc = 'MakeModelDesc',
	RetailPrice = 'RetailPrice',
	RetailPriceDesc = 'RetailPriceDesc',
	StatusDate = 'StatusDate',
	StatusDateDesc = 'StatusDateDesc',
	Year = 'Year',
	YearDesc = 'YearDesc',
	SaleDate = 'SaleDate',
	SaleDateDesc = 'SaleDateDesc',
	CreatedDate = 'CreatedDate',
	CreatedDateDesc = 'CreatedDateDesc',
	ModifiedDate = 'ModifiedDate',
	ModifiedDateDesc = 'ModifiedDateDesc',
	OpportCount = 'OpportCount',
	OpportCountDesc = 'OpportCountDesc',
	BodyStyle = 'BodyStyle',
	BodyStyleDesc = 'BodyStyleDesc',
}

export enum ContactOrderBy
{
	None = 'None',
	FirstName = 'FirstName',
	FirstNameDesc = 'FirstNameDesc',
	LastName = 'LastName',
	LastNameDesc = 'LastNameDesc',
	Company = 'Company',
	CompanyDesc = 'CompanyDesc',
	CreatedDate = 'CreatedDate',
	CreatedDateDesc = 'CreatedDateDesc',
	ModifiedDate = 'ModifiedDate',
	ModifiedDateDesc = 'ModifiedDateDesc',
}

export enum Gender
{
	/// <summary>None</summary>
	None = 'None',
	/// <summary>Female</summary>
	Female = 'Female',
	/// <summary>Male</summary>
	Male = 'Male',
	/// <summary>Other</summary>
	Other = 'Other',
}


export var GenderVals =
	[
		{
			key: Gender.None,
			val: "None",
			selectable: false
		},
		{
			key: Gender.Female,
			val: "Female"
		},
		{
			key: Gender.Male,
			val: "Male"
		},
		{
			key: Gender.Other,
			val: "Other"
		},
	]


export enum MemberVehicleOrderBy
{
	None = 0,
	StockNo = 100,
	StockNoDesc = 101,
	RegNo = 140,
	RegNoDesc = 141,
	MakeModel = 200,
	MakeModelDesc = 201,
	RetailPrice = 300,
	RetailPriceDesc = 301,
	// AgeingDate = 400,
	// AgeingDateDesc = 401,
	StatusDate = 500,
	StatusDateDesc = 501,
	Year = 600,
	YearDesc = 601,
	SaleDate = 700,
	SaleDateDesc = 701,
	CreatedDate = 800,
	CreatedDateDesc = 801,
	ModifiedDate = 900,
	ModifiedDateDesc = 901,
}

export enum LookupType
{
	External = 'External',
	Internal = 'Internal',
	ExtImage = 'ExtImage'
}

export enum PurchaseOrdersOrderBy
{
    OrderNo = 0,
    OrderDate = 100,
    ActionDate = 200
}

export enum PurchaseOrderStatus
{
    None = 0,
    Pending = 1010,
    Approved = 2010,
    Cancelled = 3010,
}

export enum PurchaseOrderInvoicedStatus
{
    None = 0,
    Uninvoiced = 1010,
    Invoiced = 2010,
}

export enum PurchaseOrderSearchField
{
    AllFields = 0,
    OrderNoList = 100000,
}


export enum OpportSortBy
{
	OpportNo = 'OpportNo',
	OpenDate = 'OpenDate',
	Customer = 'Customer',
	NextActionDate = 'NextActionDate',
	LastActionDate = 'LastActionDate',
	ClosedDate = 'ClosedDate',
	OpportNoDesc = 'OpportNoDesc',
	OpenDateDesc = 'OpenDateDesc',
	CustomerDesc = 'CustomerDesc',
	NextActionDateDesc = 'NextActionDateDesc',
	LastActionDateDesc = 'LastActionDateDesc',
	ClosedDateDesc = 'ClosedDateDesc',

}

export enum OpportunityStatus
{
	/// <summary>All</summary>
	All = -1,
	/// <summary>Open</summary>
	Open = 0,
	/// <summary>Won</summary>
	Won = 10,
	/// <summary>Lost</summary>
	Lost = 20,
}

export enum OpportunityActivityTypeEnum
{
	FinanceCalc = 1200,
	FinanceApp = 1600,
	Quote = 2000,
	TestDrive = 4000,
	Enquiry = 6000,
	Feedback = 8000,
	Sale = 10000,
	FollowUp = 12000,
	PriceMyTrade = 13000,
    LoanVehicle = 14000,
	Note = 20000,
	OutgoingEmail = 21000,
	IncomingEmail = 22000,
	VehicleWanted = 24000,
	OutgoingSMS = 25000,
	IncomingSMS = 26000
}

export enum OpportunityActivityType
{
	FinanceCalc = "FinanceCalc",
	FinanceApp = "FinanceApp",
	Quote = "Quote",
	TestDrive = "TestDrive",
	Enquiry = "Enquiry",
	Feedback = "Feedback",
	Sale = "Sale",
	FollowUp = "FollowUp",
	PriceMyTrade = "PriceMyTrade",
	Note = "Note",
	OutgoingEmail = "OutgoingEmail",
	IncomingEmail = "IncomingEmail",
	VehicleWanted = "VehicleWanted",
	OutgoingSMS = "OutgoingSMS",
	IncomingSMS = "IncomingSMS",
	LoanVehicle = "LoanVehicle",
}

export enum SaleOrderBy
{
	None = "None",
	SaleDate = "SaleDate",
	EffectiveAccountingDate = "EffectiveAccountingDate",
	VehicleStockNo = "VehicleStockNo",

    SettlementDate = "SettlementDate",
}

export enum SaleStatus
{
	All = "All",
	Accepted = "Accepted",
	Finalized = "Finalized",
	InProgress = "InProgress",
}

export enum SaleStatusFilter
{
	IncludeAll = "IncludeAll",
	ExcludeAll = "ExcludeAll",
	ShowOnly = "ShowOnly",
}

export enum SaleTypeFilter
{
	All = "All",
	Retail = "Retail",
	Wholesale = "Wholesale",
}


export enum SaleType
{
	All = "All",
	Retail = "Retail",
	Wholesale = "Wholesale",
}

export enum SystemEventOrderBy
{
    DateCreated = "DateCreated",
    UserName = "UserName",
    Environment = "Environment",
    Title = "Title",
    Description = "Description",
}

export enum SystemEventType
{   
    All = "All",
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export enum SystemEventCategory
{
    All = "All",
    SecurityLoginSuccess = "SecurityLoginSuccess",
    SecurityLoginError = "SecurityLoginError",
    SecurityAccessTokenSuccess = "SecurityAccessTokenSuccess",
    VehicleExport = "VehicleExport",
    VehicleMovement = "VehicleMovement",
    SaleCancellation = "SaleCancellation",
    SaleWorkflow = "SaleWorkflow",
    AccountingAudit = "AccountingAudit",
    DocumentAudit = "DocumentAudit",
    DataPayload = "DataPayload",
    GeneralChangeAudit = "GeneralChangeAudit",
    Advertising = "Advertising",
    ActivityChangeAudit = "ActivityChangeAudit",
    BulkUpdate = "BulkUpdate",
}

export enum WholesaleVehicleOrderBy
{
	None = 'None',
	CreatedDate = 'CreatedDate',
	ModifiedDate = 'ModifiedDate',
	Price = 'Price',
	Make = 'Make',
	Year = 'Year',
	OdometerReading = 'OdometerReading',
	RecommendationRating = 'RecommendationRating',
	CreatedDateDesc = 'CreatedDateDesc',
	ModifiedDateDesc = 'ModifiedDateDesc',
	PriceDesc = 'PriceDesc',
	MakeDesc = 'MakeDesc',
	YearDesc = 'YearDesc',
	OdometerReadingDesc = 'OdometerReadingDesc',
	RecommendationRatingDesc = 'RecommendationRatingDesc',
}

export enum WholesaleDealershipOrderBy
{
	None = 'None',
	DealershipName = 'DealershipName',
	CreatedDate = 'CreatedDate'
}

export enum ContactValidationSetting
{
	AllOptional = 'AllOptional',
	EmailMandatory = 'EmailMandatory',
	MobilePhoneMandatory = 'MobilePhoneMandatory',
	AnyMandatory = 'AnyMandatory',
	AllMandatory = 'AllMandatory',
}

export enum WholesaleVehicleSaleStatus
{
	None = 'None',
	MakeOffer = 'MakeOffer',
	BuyNow = 'BuyNow',
	//if a vehicle has both set
	BuyNowMakeOffer = '0',
}

export type FeatureFlag =
	'None' |
	'FinanceCentral_DealerLedAvailable' |
	'VehicleExchange_Available' |
    'IntegratedInsurance_Available';

export type UserRole =
	"Accounts Admin/General Admin" |
	"Business Manager" |
	"Dealer Principal" |
	"Logistics/Reconditioning" |
	"Parts/Workshop" |
	"Sales Manager" |
	"Salesperson";

export enum OpportunityProgressFlags
{
	None = 'None',
	Assigned = 'Assigned',
	Contact = 'Contact',
	Qualify = 'Qualify',
	SiteVisit = 'SiteVisit',
	TestDrive = 'TestDrive',
	Quote = 'Quote',
	Finance = 'Finance',
	Sale = 'Sale',
	Delivery = 'Delivery',
	FollowUp = 'FollowUp',
    LoanVehicle = 'LoanVehicle',
}


export type MfaFlag =
	'None' |
	'MfaSetup' |
	'MfaRequired' |
	'MfaAlwaysOff';


export enum DataWidgetType
{
	Simple = "Simple",
	List = "List",
	ListSimple = "ListSimple",
	SimpleGroup = "SimpleGroup",

}

export enum DataWidgetSentiment
{
	Neutral = "Neutral",
	Positive = "Positive",
	Negative = "Negative",
	Warning = "Warning",
}

export enum DataWidgetHeaderType
{
	Neutral = "Text",
	Positive = "Logo",
}

export enum DataWidgetDataType
{
	Vehicle_Inventory = "Vehicle_Inventory",
	Vehicle_Inventory_Breakdown = "Vehicle_Inventory_Breakdown",
	Sales_SoldProjected = "Sales_SoldProjected",
	Sales_BreakdownSummary = "Sales_BreakdownSummary",
	Opportunties_Summary = "Opportunties_Summary",
	FinanceCentral_Summary = "FinanceCentral_Summary",
	BuyerScore_Summary = "BuyerScore_Summary",
	Needacar_Summary = "Needacar_Summary",
	Marketing_Summary = "Marketing_Summary",
}

export enum DataWidgetIcon
{
	None = "None",
	Warning = "Warning",
	Forecast = "Forecast",
	DownArrow = "DownArrow",
	FinApp = "FinApp",
	UpArrow = "UpArrow",
	ThumbUp = "ThumbUp",

	Custom = "Custom",
}

export enum TimePeriodDropDownType
{
    Today = "Today",
	ThisMonth = "This Month",
	LastMonth = "Last Month",
	ThisWeek = "This Week",
	LastWeek = "Last Week",
	Last7Days = "Last 7 Days",
	Custom = "Custom",
}


export enum TabHeaderEnum
{
	None = 0,
	Home = 1,
	Vehicles = 2,
	Contacts = 3,
	Sales = 4,
	Opportunities = 5,
	Export = 6,
	Reports = 7,
	Dealerzone = 8,
	BuyerScore = 9,
	FinanceCentral = 10,
}

export enum DmsPageHeaderEnum
{
	Dashboard = "Dashboard",
	Vehicles = "Vehicles",
	Contacts = "Contacts",
	Sales = "Sales",
	Opportunities = "Opportunities",
	Exports = "Exports",
	Reports = "Reports",
    Tasks = "Tasks",
    Documents = "Documents",
    MoneyOutstanding = "Money Outstanding",
    SystemEvents = "System Events",
}

export enum AppHeaderEnum
{
	MotorcentralDms = "Motorcentral DMS",
	VehicleXchange = "VehicleXchange",
	AvantiFinance = "Avanti Finance",
	CarCheck = "Car Check",
	BuyerScore = "BuyerScore",
	AutoAttendant = "Auto Attendant",
    WebsiteAdmin = "Website Admin",
}

export enum WebsiteAdminPageHeaderEnum
{
    Vehicles = "Vehicles",
    Dealerships = "Dealerships",
    Products = "Products",
    Blog = "Blog",
    Testimonials = "Testimonials",
}

export enum VehicleXchangePageHeaderEnum
{
    Browse = "Vehicles",
    Suggested = "Suggested",
    Shortlist = "Shortlist",
    PendingBuyOffers = "Pending Buy Offers",
    AcceptedBuyOffers = "Accepted Buy Offers",
    DeclinedBuyOffers = "Declined Buy Offers",
    MyVehicles = "My Vehicles",
    PendingSellOffers = "Pending Sell Offers",
    AcceptedSellOffers = "Accepted Sell Offers",
    Questions = "Questions",
}

export enum CarCheckPageHeaderEnum
{
    RecentChecks = "Recent Checks",
    Search = "Search",
}


export enum VehicleStatusEnum
{
	AtOrigin = 4,
	InTransit = 10,
	AtCompliance = 16,
	OnYard = 20,
	AtSupplier = 30,
	OnTestDrive = 40,
	AtAuction = 42,
	OnLoan = 45,
	Sold = 50,

	Custom01 = 900001,
	Custom02 = 900002,
	Custom03 = 900003,
	Custom04 = 900004,
	Custom05 = 900005,
	Custom06 = 900006,
	Custom07 = 900007,
	Custom08 = 900008,
	Custom09 = 900009,
	Custom10 = 900010,
	Custom11 = 900011,
	Custom12 = 900012,
	Custom13 = 900013,
	Custom14 = 900014,
	Custom15 = 900015,
	Custom16 = 900016,
	Custom17 = 900017,
	Custom18 = 900018,
	Custom19 = 900019,
	Custom20 = 900020,

	Other = 1000000,
}

export enum CarcheckTrainingQuestionTypes
{
	AnswerVerifyingForPurchase = 10,
	AnswerMarketing = 20,
	AnswerConfirmingChangeOfRegisteredPerson = 30,
	AnswerVerifyingOnBehalfOfAnotherMVT = 40,
	AnswerAuthorised = 50,
	AnswerInformationAccess = 60,
	AnswerNotifyRegistrar = 70,
	AnswerPrivacyAct = 80,
	AnswerNamesAndAddresses = 90,
}
export type CarcheckTrainingQuestionDtoMapping = 'answerVerifyForPurchase' | 'answerMarketing' | 'answerConfirmingChangeOfRegisteredPerson' | 'answerVerifyingOnBehalfOfAnotherMVT' | 'answerAuthorised' | 'answerInformationAccess' | 'answerNotifyRegistrar' | 'answerPrivacyAct' | 'answerNamesAndAddresses';

export enum ProductClass
{
    General = "General",
    VehicleRegistration = "VehicleRegistration",
    VehicleInsurance = "VehicleInsurance",
    BreakdownInsurance = "BreakdownInsurance",
    PaymentInsurance = "PaymentInsurance",
    EquityInsurance = "EquityInsurance",
    VehicleServicePlan = "VehicleServicePlan",
    DocumentSignature = "DocumentSignature",
    CleanVehicleFee = "CleanVehicleFee",
    VehicleTyreStewardshipFee = "VehicleTyreStewardshipFee",
}

export enum ProductSubClass
{
    None = "None",
    PaymentProtectionInsurance = "PaymentProtectionInsurance",
}

export enum SaleBalanceType
{
	DepositOnSigning = "DepositOnSigning",
	DueOnDelivery =	"DueOnDelivery",
	AdditionalPayments = "AdditionalPayments",
	AmountToFinance = "AmountToFinance",
}

export enum SaleVehicleType
{
	Sale = 0,
	Purchase = 1,
}

export enum EntityType
{
	Vehicle = 1000,
	VehicleExpense = 1010,
	Sale = 2000,
	SaleProduct = 2010,
	Opportunity = 3000,
	System = 4000,
	Part = 5000,
	PartStocktake = 5010,
	AccPurchaseOrder = 6000,
	AccPurchaseInvoice = 6010,
	AccSaleInvoice = 6020,
	Contact = 7000,
}

export enum CustomFieldType
{
	TextArea = "TextArea",
	TextBox = "TextBox",
	NumericBox = "NumericBox",
	Dropdown = "Dropdown",
	DateInputBox = "DateInputBox",
}

export enum WebsiteAdminDealershipOrderBy
{
	Name = 'Name',
	NameDesc = 'NameDesc',
	Address = 'AddressName',
	AddressDesc = 'AddressDesc',
	StaffCount = 'StaffCount',
	StaffCountDesc = 'StaffCountDesc',
}

export enum WebsiteAdminContactOrderBy
{
	Name = 'Name',
	NameDesc = 'NameDesc',
	Address = 'AddressName',
	AddressDesc = 'AddressDesc',
	StaffCount = 'StaffCount',
	StaffCountDesc = 'StaffCountDesc',
}

export enum WebsiteTestimonialSortType
{
	Default = 1000,
	Latest = 2000,
	Oldest = 3000,
	Random = 10000,
}

export enum WebsiteProductSortType
{
	Default = 1000,
	Latest = 2000,
	Oldest = 3000,
	Random = 10000,
}
export enum TaskStatus
{
	Pending = 1000,
	Completed = 2000,
	Cancelled = 3000,
}

export enum DynamicReportTaskStateEnum
{
    Pending = 'Pending',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    Error = 'Error',
}

export enum TaskType
{
	GeneralTask = 10010,
	SendEmail = 20010,
	SendSMS = 20014,
	PhoneCall = 20020,
	Meeting = 20030,
	PrintLetter = 30010,
	RunExport = 40010,
	MarketingSendEmail = 50010,
	MarketingPrintLetter = 50020,
	MarketingSendSms = 50030,
	MarketingError = 59000,
	SyncWorkshop = 60010,
	BuyerScoreSendEmail = 70010,
	ExecuteScript = 1000010,
}

export enum TaskSortBy
{
	Title = 'Title',
	TitleDesc = 'TitleDesc',
	StartDate = 'StartDate',
	StartDateDesc = 'StartDateDesc',
	Assignee = 'Assignee',
	AssigneeDesc = 'AssigneeDesc',
	Status = 'Status',
	StatusDesc = 'StatusDesc',
	Color = 'Color',
	ColorDesc = 'ColorDesc',
}

export enum ProductSaleInvoiceSortBy
{
	InvoiceNo = 'InvoiceNo',
    InvoiceNoDesc = 'InvoiceNoDesc',
	Date = 'Date',
	DateDesc = 'DateDesc',
	Customer = 'Customer',
	CustomerDesc = 'CustomerDesc',
	Status = 'Status',
	StatusDesc = 'StatusDesc',
	Supplier = 'Supplier',
	SupplierDesc = 'SupplierDesc',
}

export enum PurchaseOrderSortBy
{
	OrderNo = 'OrderNo',
	OrderNoDesc = 'OrderNoDesc',
	Date = 'Date',
	DateDesc = 'DateDesc',
	Vehicle = 'Vehicle',
	VehicleDesc = 'VehicleDesc',
	Status = 'Status',
	StatusDesc = 'StatusDesc',
	Supplier = 'Supplier',
	SupplierDesc = 'SupplierDesc',
}

export enum ExpenseSortBy
{
	Type = 'Type',
	TypeDesc = 'TypeDesc',
	Date = 'Date',
	DateDesc = 'DateDesc',
	Amount = 'Amount',
	AmountDesc = 'AmountDesc',
	Supplier = 'Supplier',
	SupplierDesc = 'SupplierDesc',
}

export enum AccountingExportSortBy
{
	DateAsc = 'dateAsc',
	DateDesc = 'dateDesc',
	ReferenceAsc = 'referenceAsc',
	ReferenceDesc = 'referenceDesc',
	AmountAsc = 'amountAsc',
	AmountDesc = 'amountDesc',
}

export enum AccountingExportOriginType
{
	None = 0,
	VehicleExpense = 100100,
	SaleVehicle = 200100,
	SaleProduct = 200200,
	SaleFinance = 200300,
	PurchaseOrder = 300100,
	PurchaseInvoiceItem = 300201,
	SaleInvoice = 300300,
	SaleInvoiceItem = 300301,
	CustomItem = 400100,
}

export enum FilterState
{
	None = -1,
	No = 0,
	Yes = 1
}

export enum VehiclePurchaseType
{
    Import = 10,
    Trade = 20,
    OnBehalf = 30,
    Wholesale = 40,
    BuyAtGate = 50,
    OnConsignment = 60,
    Repossession = 70,
    Other = 1000000,
}

export enum VehicleExpenseSaleOrderMode
{
    None = "None",
    VehicleSupplier = "VehicleSupplier",
    SpecificParty = "SpecificParty",
}

export enum MotorcentralEdition
{
    Unknown = "Unknown",
    Solo = "Solo",
    Standard = "Standard",
    Standard_100 = "Standard_100",
    Express = "Express",
}

export enum ReportParamSetType {
    BasicCheckBox = "BasicCheckBox",
    BasicTextBox = "BasicTextBox",
    StartDate = "StartDate",
    EndDate = "EndDate",
    AsAtDate = "AsAtDate",
    SingleDate = "SingleDate",
    ExpiryDays = "ExpiryDays",
    SearchQuery = "SearchQuery",
    TaxStatus = "TaxStatus",
    Dealership = "Dealership",
    Dealership2 = "Dealership2",
    SalesPerson = "SalesPerson",
    BusinessManager = "BusinessManager",
    AppraisedBy = "AppraisedBy",
    Financier = "Financier",
    ReferralMethod = "ReferralMethod",
    VehicleStatus = "VehicleStatus",
    VehicleKeyInfo = "VehicleKeyInfo",
    VehicleSelect = "VehicleSelect",
    VehicleGroupBy = "VehicleGroupBy",
    VehicleOrderBy = "VehicleOrderBy",
    VehicleExpensePriceMode = "VehicleExpensePriceMode",
    VehicleExpenseGroupBy = "VehicleExpenseGroupBy",
    VehicleExpenseTypeCategory = "VehicleExpenseTypeCategory",
    VehicleSoldState = "VehicleSoldState",
    VehicleManufacturer = "VehicleManufacturer",
    VehicleManufacturerModel = "VehicleManufacturerModel",
    VehicleBodyStyle = "VehicleBodyStyle",
    VehicleYearRange = "VehicleYearRange",
    VehiclePriceRange = "VehiclePriceRange",
    VehicleExpenseCategory = "VehicleExpenseCategory",
    VehicleExpensePaymentStatus = "VehicleExpensePaymentStatus",
    VehiclePurchaseType = "VehiclePurchaseType",
    CarcheckReportType = "CarcheckReportType",
    Sale = "Sale",
    SaleGroupBy = "SaleGroupBy",
    SaleOrderBy = "SaleOrderBy",
    SaleSelect = "SaleSelect",
    InProgressSale = "InProgressSale",
    SaleType = "SaleType",
    TransactionMethod = "TransactionMethod",
    CustomerKeyInfo = "CustomerKeyInfo",
    VehicleAdvertTranGroupBy = "VehicleAdvertTranGroupBy",
    VehicleAdvertTranOrderBy = "VehicleAdvertTranOrderBy",
    TaskStatus = "TaskStatus",
    TaskCategory = "TaskCategory",
    MiscGroupBy = "MiscGroupBy",
    AmpdTaskGroupBy = "AmpdTaskGroupBy",
    StockPurchaseOrderBy = "StockPurchaseOrderBy",
}

export enum ReportParamType
{
    Guid = "Guid",
    Boolean = "Boolean",
    Lookup = "Lookup",
    LookupInternalSelect = "LookupInternalSelect",
    LookupExternalSelect = "LookupExternalSelect",
    Enum = "Enum",
    Integer = "Integer",
    Date = "Date",
    DateRange = "DateRange",
    String = "String",
    Select = "Select",
    Selects = "Selects",
    Lookups = "Lookups",
}

export enum ReportSpecType
{
    /// <summary>None</summary>
    None = "None",

    /// <summary>Stock</summary>
    StockGroup = "StockGroup",
    /// <summary>Purchases</summary>
    PurchasesGroup = "PurchasesGroup",
    /// <summary>Sales</summary>
    SalesGroup = "SalesGroup",
    /// <summary>Financial</summary>
    FinancialsGroup = "FinancialsGroup",
    /// <summary>Admin</summary>
    AdminGroup = "AdminGroup",
    /// <summary>Custom</summary>
    CustomGroup = "CustomGroup",

    /// <summary>Letter</summary>
    Letter = "Letter",
    /// <summary>Letter</summary>
    Email = "Email",

    /// <summary>VehicleMoreReports</summary>
    VehicleMoreReports = "VehicleMoreReports",
    /// <summary>SaleMoreReports</summary>
    SaleMoreReports = "SaleMoreReports",
}

export enum VehicleAiProvider
{
    None = "None",
    Motorcentral = "Motorcentral",
    DriveText = "DriveText",
}

export enum DocumentMainAreaEnum
{
    Dealership = 'Dealership',
    Contact = 'Contact',
    Opportunity = 'Opportunity',
    Sale = 'Sale',
    Vehicle = 'Vehicle',
    SigningRequest = 'SigningRequest',
}

export enum DialogResult
{
    None = "None",
    OK = "OK",
    Cancel = "Cancel",
    Abort = "Abort",
    Retry = "Retry",
    Ignore = "Ignore",
    Yes = "Yes",
    No = "No",
}

export enum SaleRecordType
{
    Sale = "Sale",
    Quote = "Quote",
    FinanceApp = "FinanceApp",
}

export enum VehicleCheckServiceType
{
    None = 'None',
    TestServiceHelloWorld = 'TestServiceHelloWorld',
    Basic = 'Basic',
    PPSRCheck_Internal = 'PPSRCheck_Internal',
    OwnershipHistory = 'OwnershipHistory',
    CIN = 'CIN',
    SummarySheet = 'SummarySheet',
    PurchaseAgreement = 'PurchaseAgreement',
    Full = 'Full',
    Minimal = 'Minimal',
    RucCheck_Internal = 'RucCheck_Internal',
    MR13C = 'MR13C',
    MR13C_Reversal = 'MR13C_Reversal',
    DriverLicenseVerification = 'DriverLicenseVerification',
    DriverLicenseCheck = 'DriverLicenseCheck',
    VOSA = 'VOSA',
    BackgroundCheck = 'BackgroundCheck'
}

export enum ReportType 
{
    Vosa = 'Vosa',
    Cin = 'Cin',
    FuelAndSafetyLabel = 'FuelAndSafetyLabel',
    StockIdCard = 'StockIdCard',
    SummarySheet = 'SummarySheet',
    BuyerScoreVehicleReport = 'BuyerScoreVehicleReport',
    SaleCin = 'SaleCin',
    WholesaleInvoice = 'WholesaleInvoice',
    Mr13bTextOnly = 'Mr13bTextOnly',
    DeliveryChecklist = 'DeliveryChecklist',
    Payment = 'Payment',
    Mr1bTextOnly = 'Mr1bTextOnly',
    FinancialDetails = 'FinancialDetails',
    PurchaseAgreement = 'PurchaseAgreement',
    FuelEconomyLabel = 'FuelEconomyLabel',
    OnBehalfAgreement = 'OnBehalfAgreement',
    PlainTextTemplate = 'PlainTextTemplate',
    AccSaleInvoice = 'AccSaleInvoice',
}

export enum CommunicationsEntityType
{
    Contact = "Contact",
    Vehicle = "Vehicle",
    Sale = "Sale",
    Activity = "Activity",
    SaleProduct = "SaleProduct",
    Invoice = "Invoice",
    Statement = "Statement",
    SigningRequest = "SigningRequest",
}
export enum TextFormat
{
    PlainText = "PlainText",
    RichTextFormat = "RichTextFormat",
    HtmlFormat = "HtmlFormat",
}

export enum ExternalProcessorControlledField {
    // Identifiers
    VehicleClass = "VehicleClass",
    VehicleStatus = "VehicleStatus",
    StockNo = "StockNo",
    StockNoAlt = "StockNoAlt",
    VIN = "VIN",
    RegNo = "RegNo",
    ChassisNo = "ChassisNo",
    EngineNo = "EngineNo",
    Manufacturer = "Manufacturer",
    ManuYear = "ManuYear",
    Model = "Model",
    Variant = "Variant",
    VariantAlt = "VariantAlt",
    BodyStyle = "BodyStyle",
    RegYearLocal = "RegYearLocal",
    VehicleRecordType = "VehicleRecordType",
    MediumDesc = "MediumDesc",
    ShortDesc = "ShortDesc",
    ReIntroDate = "ReIntroDate",
    Name = "Name",
    Reference = "Reference",
    Comment = "Comment",
    Description = "Description",

    // Purchase
    PurchaseType = "PurchaseType",
    PurchaseDesc = "PurchaseDesc",
    PurchaseDate = "PurchaseDate",
    AuctionGrade = "AuctionGrade",
    AppraisalTaxRate = "AppraisalTaxRate",
    AppraisalAmount = "AppraisalAmount",
    AppraisalTaxAmount = "AppraisalTaxAmount",
    AppraisalNotes = "AppraisalNotes",
    VesselDepartDate = "VesselDepartDate",
    DeliveryPort = "DeliveryPort",
    VesselName = "VesselName",
    VoyageName = "VoyageName",
    PortArrivalDate = "PortArrivalDate",
    YardArrivalDate = "YardArrivalDate",
    RegYear = "RegYear",
    PrevOwnerTypeId = "PrevOwnerTypeId",
    PrevCountry = "PrevCountry",
    PrevOwnerNo = "PrevOwnerNo",
    PurchaseFlagsImportedAsDamaged = "PurchaseFlagsImportedAsDamaged",
    PurchaseFlagsHasSecurityInterest = "PurchaseFlagsHasSecurityInterest",
    PurchaseFlagsIsBrandNew = "PurchaseFlagsIsBrandNew",
    PurchaseFlagsAutoCalcImportTax = "PurchaseFlagsAutoCalcImportTax",
    PurchaseFlagsTraderAcquisitionApplies = "PurchaseFlagsTraderAcquisitionApplies",
    PurchaseFlagsTraderAcquisitionCompleted = "PurchaseFlagsTraderAcquisitionCompleted",
    PurchaseFlagsCarCheckStolen = "PurchaseFlagsCarCheckStolen",
    PurchaseFlagsCarCheckMoneyOwing = "PurchaseFlagsCarCheckMoneyOwing",
    PurchaseFlagsCarCheckDamagedImport = "PurchaseFlagsCarCheckDamagedImport",
    PurchaseFlagsCarCheckReRegistered = "PurchaseFlagsCarCheckReRegistered",
    PurchaseFlagsCarCheckBackgroundCharged = "PurchaseFlagsCarCheckBackgroundCharged",
    PurchaseFlagsCarCheckBackgroundPublish = "PurchaseFlagsCarCheckBackgroundPublish",
    PurchaseFlagsNotYetComplied = "PurchaseFlagsNotYetComplied",
    PurchaseFlagsExDemo = "PurchaseFlagsExDemo",
    PurchaseFlagsAvailableToOrderOnly = "PurchaseFlagsAvailableToOrderOnly",

    // Exterior
    ExtColor1 = "ExtColor1",
    ExtColor2 = "ExtColor2",
    DoorNo = "DoorNo",
    SunroofId = "SunroofId", 
    WheelSize = "WheelSize", 
    WheelComp = "WheelComp", 
    TyreCondition = "TyreCondition", 
    ExteriorFeatures = "ExteriorFeatures", 

    // Interior
    IntColor1 = "IntColor1", 
    IntTrim = "IntTrim", 
    SeatNo = "SeatNo", 
    SeatMaterial = "SeatMaterial", 
    AudioFlagsCassettePlayer = "AudioFlagsCassettePlayer",
    AudioFlagsCDPlayer = "AudioFlagsCDPlayer",
    AudioFlagsBandExpander = "AudioFlagsBandExpander",
    AirbagNo = "AirbagNo", 
    InteriorFeatures = "InteriorFeatures", 

    // Mechanical
    EngineType1 = "EngineType1", 
    CylinderNo = "CylinderNo", 
    Turbo = "Turbo", 
    DriveSystem = "DriveSystem", 
    EngineSize = "EngineSize", 
    EngineSizeUnit = "EngineSizeUnit", 
    FuelType1 = "FuelType1", 
    FuelType2 = "FuelType2", 
    Transmission = "Transmission", 
    OdoStatus = "OdoStatus", 
    OdoReading = "OdoReading", 
    OdoUnit = "OdoUnit", 
    OdoDate = "OdoDate", 
    FuelSaver = "FuelSaver", 
    MechanicalFlagsOdometerCertified = "MechanicalFlagsOdometerCertified",
    MechanicalFlagsABSBraking = "MechanicalFlagsABSBraking",
    MechanicalFlagsTractionControl = "MechanicalFlagsTractionControl",
    MechanicalFeatures = "MechanicalFeatures", 

    // Admin
    RetailPriceAmount = "RetailPriceAmount",
    RetailPriceTaxStatusEnum = "RetailPriceTaxStatusEnum",
    RetailPriceTaxAmount = "RetailPriceTaxAmount",
    WholesalePrice = "WholesalePrice",
    WholesalePriceTaxStatusEnum = "WholesalePriceTaxStatusEnum",
    WholesalePriceTaxAmount = "WholesalePriceTaxAmount",
    OtherPrice1Amount = "OtherPrice1Amount",
    OtherPrice1TaxStatusEnum = "OtherPrice1TaxStatusEnum",
    OtherPrice1TaxAmount = "OtherPrice1TaxAmount",
    OtherPrice2Amount = "OtherPrice2Amount",
    OtherPrice2TaxStatusEnum = "OtherPrice2TaxStatusEnum",
    OtherPrice2TaxAmount = "OtherPrice2TaxAmount",
    PriceTaxRate = "PriceTaxRate", 
    OfferText = "OfferText", 
    OfferEndDate = "OfferEndDate", 
    StartPriceAmount = "StartPriceAmount", 
    ReservePriceAmount = "ReservePriceAmount", 
    BuyNowPriceAmount = "BuyNowPriceAmount", 
    RegExpiryDate = "RegExpiryDate", 
    COFExpiryDate = "COFExpiryDate", 
    RoadUserEnd = "RoadUserEnd", 
    AdminFlagsIncludeExport = "AdminFlagsIncludeExport", 
    AdminFlagsExcludeExport = "AdminFlagsExcludeExport", 
    AdminFlagsRegisteredLocal = "AdminFlagsRegisteredLocal", 
    AdminFlagsReRegisteredLocal = "AdminFlagsReRegisteredLocal", 
    AdminFlagsRoadUserChargesApply = "AdminFlagsRoadUserChargesApply", 
    AdminFlagsRoadUserChargesOutstanding = "AdminFlagsRoadUserChargesOutstanding", 
    AdminFlagsIsFeatured = "AdminFlagsIsFeatured", 
    AdminFlagsDisableFinance = "AdminFlagsDisableFinance", 
    AdminFlagsIncludeGroups = "AdminFlagsIncludeGroups", 
    AdminFlagsIsSuperFeatured = "AdminFlagsIsSuperFeatured", 
    AdminFlagsIsFeaturedNeedacar = "AdminFlagsIsFeaturedNeedacar", 
    AdminFlagsIsFeaturedTradeMe = "AdminFlagsIsFeaturedTradeMe", 
    AdminFlagsIsSuperFeaturedTradeMe = "AdminFlagsIsSuperFeaturedTradeMe", 
    AdminFlagsIsShowroomTradeMe = "AdminFlagsIsShowroomTradeMe", 
    AdminFlagsIsCleanVehicleFeeInclusive = "AdminFlagsIsCleanVehicleFeeInclusive", 
    AdminFlagsIsApplyStandardVehicleText = "AdminFlagsIsApplyStandardVehicleText", 

    // Insurance
    ModifiedValue = "ModifiedValue",
    ModifiedDesc = "ModifiedDesc",
    InsuranceFlagsHasModificationsSpecified = "InsuranceFlagsHasModificationsSpecified", 
    InsuranceFlagsHasModificationsYes = "InsuranceFlagsHasModificationsYes",
    InsuranceFlagsHasCertifiedSuspensionSpecified = "InsuranceFlagsHasCertifiedSuspensionSpecified",
    InsuranceFlagsHasCertifiedSuspensionYes = "InsuranceFlagsHasCertifiedSuspensionYes",
    InsuranceFlagsHasExternalVentedAfterMarketAirFilterPodSpecified = "InsuranceFlagsHasExternalVentedAfterMarketAirFilterPodSpecified",
    InsuranceFlagsHasExternalVentedAfterMarketAirFilterPodYes = "InsuranceFlagsHasExternalVentedAfterMarketAirFilterPodYes",
    InsuranceFlagsHasIntercoolerUpgradeSpecified = "InsuranceFlagsHasIntercoolerUpgradeSpecified",
    InsuranceFlagsHasIntercoolerUpgradeYes = "InsuranceFlagsHasIntercoolerUpgradeYes",
    InsuranceFlagsHasPerformanceEnhancingComputerOrChipUpgradeSpecified = "InsuranceFlagsHasPerformanceEnhancingComputerOrChipUpgradeSpecified",
    InsuranceFlagsHasPerformanceEnhancingComputerOrChipUpgradeYes = "InsuranceFlagsHasPerformanceEnhancingComputerOrChipUpgradeYes",
    InsuranceFlagsHasBlowoffValveSpecified = "InsuranceFlagsHasBlowoffValveSpecified",
    InsuranceFlagsHasBlowoffValveYes = "InsuranceFlagsHasBlowoffValveYes",
    InsuranceFlagsHasExhaustModsSensorsIntactSpecified = "InsuranceFlagsHasExhaustModsSensorsIntactSpecified",
    InsuranceFlagsHasExhaustModsSensorsIntactYes = "InsuranceFlagsHasExhaustModsSensorsIntactYes",
    InsuranceFlagsHasExclusionsSpecified = "InsuranceFlagsHasExclusionsSpecified",
    InsuranceFlagsHasExclusionsYes = "InsuranceFlagsHasExclusionsYes",

    // Tracking
    EstRegExpiryDate = "EstRegExpiryDate",
    EstCOFExpiryDate = "EstCOFExpiryDate",

    // Battery
    BatPower = "BatPower",
    BatRange = "BatRange",
    BatHealth = "BatHealth",

    // GoodsVehicle
    ChassisType = "ChassisType", 
    ChassisExtras = "ChassisExtras", 
    Wheelbase = "Wheelbase", 
    DeckLength = "DeckLength", 
    DeckWidth = "DeckWidth", 
    DeckHeight = "DeckHeight", 
    Tare = "Tare", 
    GVM = "GVM", 
    GLW = "GLW", 
    WheelConfig = "WheelConfig", 
    TyreConfig = "TyreConfig", 
    EngineManufacturer = "EngineManufacturer", 
    EngineModel = "EngineModel", 
    EngineHP = "EngineHP", 
    EngineTorque = "EngineTorque", 
    TransmissionManufacturer = "TransmissionManufacturer", 
    TransmissionModel = "TransmissionModel", 
    HubSerialNo = "HubSerialNo", 
    HubModelNo = "HubModelNo", 

    // Caravan
    BerthNo = "BerthNo",

    // Boat
    EngineYear = "EngineYear",
    EngineHours = "EngineHours",

    // Children
    VehicleExpenses = "VehicleExpenses",
    VehicleImages = "VehicleImages",
    SalesPerson = "SalesPerson",
    Appraiser = "Appraiser",
}

export enum FormFieldType
{
    None = 'None',
    General_Disclaimer = 'General_Disclaimer',
    General_DigitalDisclosure = 'General_DigitalDisclosure',

    Customer_CompanyName = 'Customer_CompanyName',
    Customer_ContactSalutation = 'Customer_ContactSalutation',
    Customer_ContactFirstName = 'Customer_ContactFirstName',
    Customer_ContactLastName = 'Customer_ContactLastName',
    Customer_ContactBirthDate = 'Customer_ContactBirthDate',
    Customer_ContactJobTitle = 'Customer_ContactJobTitle',

    Customer_Salutation = 'Customer_Salutation',
    Customer_FirstName = 'Customer_FirstName',
    Customer_LastName = 'Customer_LastName',
    Customer_BirthDate = 'Customer_BirthDate',
    Customer_JobTitle = 'Customer_JobTitle',
    Customer_EmploymentStatus = 'Customer_EmploymentStatus',

    Customer_PostalAddress = 'Customer_PostalAddress',
    Customer_Phone = 'Customer_Phone',
    Customer_PrimaryEmail = 'Customer_PrimaryEmail',
    Customer_OtherInsuranceProducts = 'Customer_OtherInsuranceProducts',

    Vehicle_Model = 'Vehicle_Model',
    Vehicle_ManuYear = 'Vehicle_ManuYear',
    Vehicle_RegNo = 'Vehicle_RegNo',
    Vehicle_VIN = 'Vehicle_VIN',
    Vehicle_ExtColor1 = 'Vehicle_ExtColor1',
    Vehicle_EngineSize = 'Vehicle_EngineSize',
    Vehicle_EngineType = 'Vehicle_EngineType',
    Vehicle_FuelType1 = 'Vehicle_FuelType1',
    Vehicle_CylinderNo = 'Vehicle_CylinderNo',
    Vehicle_Transmission = 'Vehicle_Transmission',
    Vehicle_Turbo = 'Vehicle_Turbo',
    Vehicle_DriveSystem = 'Vehicle_DriveSystem',
    Vehicle_OdoReading = 'Vehicle_OdoReading',
    Vehicle_OriginType = 'Vehicle_OriginType',
    Vehicle_HasModifications = 'Vehicle_HasModifications',
    Vehicle_ModificationItems = 'Vehicle_ModificationItems',
    Vehicle_ModificationValue = 'Vehicle_ModificationValue',
    Vehicle_ModificationDescription = 'Vehicle_ModificationDescription',
    Vehicle_SaleAmount = 'Vehicle_SaleAmount',

    Sale_InsCompany = 'Sale_InsCompany',
    Sale_HasCashDeposit = 'Sale_HasCashDeposit',

    Sale_Finance_FinCompany = 'Sale_Finance_FinCompany',
    Sale_Finance_FinAmount = 'Sale_Finance_FinAmount',
    Sale_Finance_FinTermCount = 'Sale_Finance_FinTermCount',
    Sale_Finance_FinTermPeriod = 'Sale_Finance_FinTermPeriod',
    Sale_Finance_Installment = 'Sale_Finance_Installment',
    Sale_Finance_StartDate = 'Sale_Finance_StartDate',
    Sale_Finance_Reference = 'Sale_Finance_Reference',
    Sale_Finance_SecurityType = 'Sale_Finance_SecurityType',

    Sale_Product_StartDate = 'Sale_Product_StartDate',
    Sale_Product_SaleAmount = 'Sale_Product_SaleAmount',
    Sale_Product_PaymentType = 'Sale_Product_PaymentType',
    Sale_Product_DynamicQuestions = 'Sale_Product_DynamicQuestions',
    Sale_Product_Drivers = 'Sale_Product_Drivers',
    Sale_Product_Vehicle_GaragingArea = 'Sale_Product_Vehicle_GaragingArea',
    Sale_Product_Vehicle_OvernightParkingType = 'Sale_Product_Vehicle_OvernightParkingType',
    Sale_Product_Vehicle_AnnualDistanceDriven = 'Sale_Product_Vehicle_AnnualDistanceDriven',
    Sale_Product_Vehicle_IntendedUseType = 'Sale_Product_Vehicle_IntendedUseType',

    Sale_Product_PaymentMethod = 'Sale_Product_PaymentMethod',
    Sale_Product_PaymentPeriod = 'Sale_Product_PaymentPeriod',
    Sale_Product_Immobilizer = 'Sale_Product_Immobilizer',
    Sale_Product_PaymentFrequency = 'Sale_Product_PaymentFrequency',
    Sale_Product_PaymentDay = 'Sale_Product_PaymentDay',
    Sale_Product_PaymentDate = 'Sale_Product_PaymentDate',
    Sale_Product_PaymentCustomerName = 'Sale_Product_PaymentCustomerName',
    Sale_Product_PaymentPostalAddress = 'Sale_Product_PaymentPostalAddress',
    Sale_Product_PaymentBankAcc = 'Sale_Product_PaymentBankAcc',

    Sale_Product_PremiumSummary = 'Sale_Product_PremiumSummary',

    Sale_Product_Option_RoadsideAssistance = 'Sale_Product_Option_RoadsideAssistance',
    Sale_Product_Option_WindscreenCover = 'Sale_Product_Option_WindscreenCover',
    Sale_Product_Option_AllowUndisclosedDrivers = 'Sale_Product_Option_AllowUndisclosedDrivers',
    Sale_Product_Option_AllowDriversUnder25 = 'Sale_Product_Option_AllowDriversUnder25',

    Sale_Product_Option_VehicleUseHireReward = 'Sale_Product_Option_VehicleUseHireReward',
    Sale_Product_Option_AdditionalTowingCap = 'Sale_Product_Option_AdditionalTowingCap',
    Sale_Product_Option_ConsumableCover = 'Sale_Product_Option_ConsumableCover',
    Sale_Product_Option_DiagnosticCover = 'Sale_Product_Option_DiagnosticCover',

    Sale_Product_IsVehicleInVehicleStock = 'Sale_Product_IsVehicleInVehicleStock',
    Sale_Product_IsPolicySaleTimeArranged = 'Sale_Product_IsPolicySaleTimeArranged',
    Sale_Product_VehicleDepositShortfallAcknowledged = 'Sale_Product_VehicleDepositShortfallAcknowledged',

    Driver_Salutation = 'Driver_Salutation',
    Driver_FirstName = 'Driver_FirstName',
    Driver_LastName = 'Driver_LastName',
    Driver_BirthDate = 'Driver_BirthDate',
    Driver_Gender = 'Driver_Gender',
    Driver_PercentageUse = 'Driver_PercentageUse',
    Driver_LicenceType = 'Driver_LicenceType',
    Driver_LicenceYears = 'Driver_LicenceYears',
    Driver_LicenceCountry = 'Driver_LicenceCountry',
    Driver_IncidentNumberLast5Years = 'Driver_IncidentNumberLast5Years',
    Driver_IncidentNumberLast12Months = 'Driver_IncidentNumberLast12Months',
    Driver_CurrentInsurer = 'Driver_CurrentInsurer',
}

export enum FormFieldEventType
{
    None = 'None',
    Information = 'Information',
    Warning = 'Warning',
    Error = 'Error',
}

export enum QuestionResult
{
    None = 'None',
    Yes = 'Yes',
    No = 'No'
}

export enum InsuranceParamType
{
    Guid = "Guid",
    Boolean = "Boolean",
    Lookup = "Lookup",
    LookupInternalSelect = "LookupInternalSelect",
    LookupExternalSelect = "LookupExternalSelect",
    Enum = "Enum",
    Integer = "Integer",
    Date = "Date",
    DateRange = "DateRange",
    String = "String",
    Select = "Select",
    Selects = "Selects",
    Lookups = "Lookups",
    YesNo = "YesNo",
    LongText = "LongText",
    Price = "Price",
    DisplayText = "DisplayText",
    Checkbox = "Checkbox",
}

export enum InsuranceParamGroup
{
    ResponsibleLendingCodeTermsConditions = "ResponsibleLendingCodeTermsConditions",
    CustomerInformation = "CustomerInformation",
    CustomerDisclosure = "CustomerDisclosure",
    VehicleInformation = "VehicleInformation",
    FinanceInsuranceInformation = "FinanceInsuranceInformation",
    PaymentDetails = "PaymentDetails",
    Drivers = "Drivers",
    GeneralQuestions = "GeneralQuestions",
    AdditionalQuestions = "AdditionalQuestions",

}

export enum WorkflowStatus
{
    None = "None",
    Incomplete = "Incomplete",
    Pending = "Pending",
    Complete = "Complete",
}

export enum WorkflowAction
{
    None = "None",
    Quote = "Quote",
    OrderPending = "OrderPending",
    OrderConfirmed = "OrderConfirmed",
    OrderCancelled = "OrderCancelled",
}

export enum Salutation
{
    None = "None",
    Mr = "Mr",
    Mrs = "Mrs",
    Ms = "Ms",
    Miss = "Miss",
    Dr = "Dr",
    Other = "Other",
}

export enum PlateVinCheck
{
    Plate = "Plate",
    Vin = "Vin",
}
export enum ExportSpecProvider
{
    Custom = 0,
    Motorcentral = 102040000,
    MotorcentralAPI = 122040000,
    MotorcentralWebsite = 123040000,
    MotorcentralExternal = 182040000,
    AutoBase = 200000010,
    TradeMe = 200000020,
    Dealerbase = 200000030,
    DealerPoint = 300000010,
    ClassicType1 = 400000010,
    Facebook = 500000010,
}

export enum ExportPersistType
{
    File = 10,
    FTP = 20,
    SFTP = 25,
    S3 = 30,
    TradeMe = 1000,
    TradeMeSandbox = 1001,
    Dealerbase = 1100,
    DealerbaseSandbox = 1101,
    Storage = 2000,
    MotorcentralAPI = 3000,
}

export enum ExportFormatType
{
    CSV = 10,
    XML = 20,
    TradeMe = 1000,
    DealerbaseApi = 1010,
}

export enum ExportDataFilter
{
    IncrementalData = 10,
    FullData = 20,
}

export enum ExportVehicleField
{
    VehicleId = 100010,
    ShortDesc = 100020,
    VehicleClass = 100030,
    VehicleClassEnum = 100031,
    Dealership = 100040,
    DealershipCode = 100042,
    VehicleStatus = 100050,
    VehicleStatusEnum = 100051,
    VehicleStatusDesc = 100060,
    SaleStatus = 100061,
    SaleStatusEnum = 100062,
    Manufacturer = 100070,
    ManufacturerEnum = 100071,
    Model = 100080,
    Variant = 100090,
    StockNo = 100100,
    VIN = 100110,
    RegNo = 100120,
    RegYearLocal = 100130,
    ChassisNo = 100140,
    EngineNo = 100150,
    ManuYear = 100160,
    BodyStyle = 100170,
    BodyStyleEnum = 100171,
    BodyStyleInternal = 100172,
    PurchaseDate = 100180,
    PurchaseType = 100190,
    PurchaseTypeEnum = 100191,
    YardArrivalDate = 100240,
    VesselDepartDate = 100250,
    PortDelivery = 100260,
    VesselName = 100270,
    VoyageName = 100272,
    PortArrivalDate = 100280,
    RegYear = 100290,
    PrevOwnerType = 100300,
    PrevOwnerTypeEnum = 100301,
    PrevCountry = 100310,
    PrevOwnerNo = 100320,
    PurchaseFlags = 100330,
    ExtColor1 = 100340,
    ExtColor2 = 100350,
    DoorNo = 100360,
    Sunroof = 100370,
    SunroofEnum = 100371,
    WheelSize = 100380,
    WheelComp = 100390,
    WheelCompEnum = 100391,
    TyreCondition = 100400,
    TyreConditionEnum = 100401,
    ExteriorFeatures = 100410,
    IntColor1 = 100420,
    IntTrim = 100430,
    IntTrimEnum = 100431,
    SeatNo = 100440,
    SeatMaterial = 100450,
    SeatMaterialEnum = 100451,
    AudioFlags = 100460,
    AirbagNo = 100470,
    InteriorFeatures = 100480,
    EngineSize = 100490,
    EngineSizeUnit = 100500,
    EngineSizeUnitEnum = 100501,
    EngineType1 = 100510,
    EngineType1Enum = 100511,
    FuelType1 = 100520,
    FuelType1Enum = 100521,
    FuelType2 = 100530,
    FuelType2Enum = 100531,
    CylinderNo = 100536,
    Transmission = 100540,
    TransmissionEnum = 100541,
    TransmissionInternal = 100542,
    Turbo = 100550,
    TurboEnum = 100551,
    DriveSystem = 100560,
    DriveSystemEnum = 100561,
    OdoStatus = 100570,
    OdoStatusEnum = 100571,
    OdoReading = 100580,
    OdoUnit = 100590,
    OdoUnitEnum = 100591,
    OdoCaption = 100595,
    OdoDate = 100600,
    MechFlags = 100610,
    MechanicalFeatures = 100620,
    FuelSaverLabelFormat = 100624,
    FuelSaverFuelType = 100625,
    FuelSaverRating = 100630,
    FuelSaverCost = 100640,
    FuelSaverMileage = 100650,
    FuelSaverElectricConsumption = 100651,
    FuelSaverElectricRange = 100652,
    FuelSaverMake = 100656,
    FuelSaverModel = 100657,
    FuelSaverNote = 100660,
    FuelSaverLabelID = 100661,
    FuelSaverDate = 100670,
    FuelSaverPromoBadge = 100671,
    RetailPriceTaxStatus = 100680,
    RetailPriceTaxStatusEnum = 100681,
    RetailPriceAmount = 100690,
    RetailPriceTaxAmount = 100700,
    WholesalePriceTaxStatus = 100710,
    WholesalePriceTaxStatusEnum = 100711,
    WholesalePriceAmount = 100720,
    WholesalePriceTaxAmount = 100730,
    Other1PriceTaxStatus = 100740,
    Other1PriceTaxStatusEnum = 100741,
    Other1PriceAmount = 100750,
    Other1PriceTaxAmount = 100760,
    Other2PriceTaxStatus = 100770,
    Other2PriceTaxStatusEnum = 100771,
    Other2PriceAmount = 100780,
    Other2PriceTaxAmount = 100790,
    RegExpiryDate = 100800,
    COFExpiryDate = 100810,
    AdminFlags = 100820,
    Name = 100830,
    Reference = 100840,
    Comment = 100850,
    Description = 100860,
    CreatedDate = 100870,
    CreatedBy = 100880,
    ModifiedDate = 100890,
    ModifiedBy = 100900,
    CustomField1 = 100910,
    CustomField2 = 100920,
    CustomField3 = 100930,
    CustomField4 = 100940,
    CustomField5 = 100950,
    CustomField6 = 100960,
    CustomField7 = 100961,
    CustomField8 = 100962,
    CustomField9 = 100963,
    CustomField10 = 100964,
    CustomField11 = 100965,
    CustomField12 = 100966,
    CustomField13 = 100967,
    CustomField14 = 100968,
    CustomField15 = 100969,
    ChassisType = 100970,
    ChassisExtras = 100980,
    Wheelbase = 100990,
    DeckLength = 101000,
    DeckWidth = 101001,
    DeckHeight = 101002,
    Tare = 101010,
    Payload = 101012,
    GVM = 101020,
    GLW = 101030,
    GCW = 101040,
    WheelConfig = 101050,
    TyreConfig = 101060,
    EngineManu = 101070,
    EngineModel = 101080,
    EngineHP = 101090,
    EngineTorque = 101100,
    TransManu = 101110,
    TransModel = 101120,
    BerthNo = 101130,
    Length = 101140,
    Beam = 101150,
    Draft = 101160,
    Propulsion = 101170,
    PropulsionEnum = 101171,
    Horsepower = 101180,
    EngineHours = 101190,
    ConstructionType = 101200,
    ConstructionTypeEnum = 101210,
    DriverSafetyStars = 101220,
    DriverSafetyTest = 101230,
    DriverSafetyPromoBadge = 101240,
    IsNew = 101250,
    ImportHistory = 101260,
    YouTubeId = 101270,
    YouTubeURL = 101272,
    SphericalPhotoURL = 101280,
    ElectricBatteryPower = 101290,
    ElectricBatteryRange = 101300,
    ElectricBatteryHealth = 101310,
    CleanVehicleText = 101320,
    CleanVehicleInd = 101330,
    CleanVehicleMode = 101340,
    CleanVehicleAmount = 101350,
    CleanVehicleAmountMax = 101352,
    CleanVehicleDisclaimerLong = 101360,
    CleanVehicleOtherTextLong = 101370,
    CleanVehicleDisplayLabel = 101372,
    CO2 = 101380,
    CO2Max = 101390,
    CO2Stars = 101400,
    CO2StarsText = 101410,
    CO2Text = 101420,
    CO2Yearly = 101421,
    FuelStarsText = 101430,
    AnnFuelCostText = 101440,
    FuelEconomyText = 101450,
    FuelEconomyDisclaimer = 101460,
    DriverSafetyDisclaimerLong = 101470,
    SafetyStars = 101480,
    SafetyStarsText = 101490,
    CrashAvoidanceStars = 101500,
    CrashAvoidanceDisclaimer = 101510,
    ExtColor1RGB = 110010,
    ExtColor2RGB = 110020,
    IntColor1RGB = 110030,
    RetailPriceAmountIncl = 110040,
    RetailPriceAmountExcl = 110041,
    RetailPriceAmountInclDisplay = 110042,
    RetailPriceAmountExclDisplay = 110043,
    WholesalePriceAmountIncl = 110050,
    WholesalePriceAmountExcl = 110051,
    WholesalePriceAmountInclDisplay = 110052,
    WholesalePriceAmountExclDisplay = 110053,
    Other1PriceAmountIncl = 110060,
    Other1PriceAmountExcl = 110061,
    Other1PriceAmountInclDisplay = 110062,
    Other1PriceAmountExclDisplay = 110063,
    Other2PriceAmountIncl = 110070,
    Other2PriceAmountExcl = 110071,
    Other2PriceAmountInclDisplay = 110072,
    Other2PriceAmountExclDisplay = 110073,
    ExcludesGST = 110074,
    StandardManuYear = 120010,
    StandardManufacturer = 120020,
    StandardModel = 120030,
    StandardVariant = 120040,
    FinanceTermCount = 190010,
    FinanceTermPeriodEnum = 190020,
    FinanceInterestRate = 190030,
    FinanceInterestRateDisplay = 190032,
    FinanceEstFee = 190040,
    FinanceEstFeeDisplay = 190042,
    FinanceSecRegFee = 190050,
    FinanceSecRegFeeDisplay = 190052,
    FinanceAdminFee = 190060,
    FinanceAdminFeeDisplay = 190062,
    FinanceAdminFeePeriodEnum = 190070,
    FinanceDepositRateMethodEnum = 190110,
    FinanceDepositAmount = 190120,
    FinanceDepositAmountDisplay = 190122,
    FinanceEffectiveSaleAmount = 190130,
    FinanceEffectiveSaleAmountDisplay = 190132,
    FinanceEffectiveDepositAmount = 190140,
    FinanceEffectiveDepositAmountDisplay = 190142,
    FinanceAmount = 190210,
    FinanceAmountDisplay = 190212,
    FinanceRepaymentTotal = 190220,
    FinanceRepaymentTotalDisplay = 190222,
    FinanceRepaymentPerWeek = 190230,
    FinanceRepaymentPerWeekDisplay = 190232,
    FinanceRepaymentPerWeek48 = 190234,
    FinanceRepaymentPerWeek48Display = 190236,
    FinanceRepayableTotalAmount = 190240,
    FinanceRepayableTotalAmountDisplay = 190242,
    FinanceFinanceRepaymentPerWeekCaption = 190310,
    FinanceRepayableTotalAmountCaption = 190320,
    FinanceDepositCaption = 190330,
    FinanceFooterCaption = 190340,
    FinanceApplicationUrl = 190350,
    IsFeatured = 200010,
    IsSuperFeatured = 200011,
    DisableFinance = 200020,
    AuctionExport = 200030,
    StartPriceAmount = 200040,
    ReservePriceAmount = 200050,
    BuyNowPriceAmount = 200060,
    VehicleOfferText = 200070,
    VehicleOfferEndDate = 200080,
    InTransit = 200090,
    AvailableToOrder = 200100,
    ExDemo = 200110,
    ORCIncluded = 210010,
    SiteLinkURL = 210030,
    AllFeatures = 210040,
    AllFeaturesDashSeparated = 210042,
    ImageIndexList = 210050,
    CarCheckReference = 210070,
    CarCheckDate = 210075,
    CarCheckStolen = 210080,
    CarCheckMoneyOwing = 210090,
    CarCheckDamagedImport = 210100,
    CarCheckReRegistered = 210110,
    IsHot = 220010,
    StandardFeatures = 220020,
    StandardFeaturesEnum = 220022,
    SimilarVehicles = 220030,
    IsRecentPriceDrop = 220040,
    AppraisalNotes = 230010,
    AuctionGrade = 230020,
    NotYetComplied = 230030,
    Layout = 230040,
    DescriptionRaw = 240010,
    VehicleHighlight1Title = 250010,
    VehicleHighlight1Description = 250012,
    VehicleHighlight1Icon = 250013,
    VehicleHighlight1IsAiGenerated = 250014,
    VehicleHighlight1ShowOnWebsite = 250015,
    VehicleHighlight2Title = 250020,
    VehicleHighlight2Description = 250022,
    VehicleHighlight2Icon = 250023,
    VehicleHighlight2IsAiGenerated = 250024,
    VehicleHighlight2ShowOnWebsite = 250025,
    VehicleHighlight3Title = 250030,
    VehicleHighlight3Description = 250032,
    VehicleHighlight3Icon = 250033,
    VehicleHighlight3IsAiGenerated = 250034,
    VehicleHighlight3ShowOnWebsite = 250035,
}

export enum ExportVehicleAction
{
    NoAction = 0,
    UpdateListing = 1000,
    NewListing = 2000,
    Relist = 2100,
    RecreateListing = 2200,
    Withdraw = 3000,
}

export enum ExportVehicleDuration
{
    Unset = -1,
    EndDate = 0,
    Two = 2,
    Three = 3,
    Four = 4,
    Five = 5,
    Six = 6,
    Seven = 7,
    Ten = 10,
    Fourteen = 14,
}

export enum ExportDescInsertPosition
{
    None = 0,
    TopCommaSeparated = 10,
    TopBulletPoints = 11,
    BottomCommaSeparated = 20,
    BottomBulletPoints = 21,
}

export enum ExportBestContactTime
{
    Anytime = 0,
    Morning = 10,
    Afternoon = 20,
    Evening = 30,
    BusinessHours = 40,
}

export enum ExportColumnNamesTransformMode
{
    None = 0,
    Simple = 10,
    ClassicType1 = 20,
}

export enum ExportPartField
{
    PartId = 100010,
    Name = 100020,
    Reference = 100030,
    SupplierCode = 100031,
    Comment = 100040,
    Description = 100050,
    PrefSupplier = 100060,
    PrefSupplierId = 100061,
    Category = 100070,
    CategoryId = 100071,
    Dealership = 100080,
    DealershipId = 100081,
    PurAmount = 100090,
    PurTaxEnum = 100091,
    SaleTaxEnum = 100092,
    SaleAmount = 100093,
    StockQty = 100100,
    LastStockTake = 100101,
    LastStockTakeQty = 100103,
    ReorderQty = 100102,
    Location = 100110,
    CreatedDate = 100120,
    CreatedBy = 100121,
    ModifiedDate = 100122,
    ModifiedBy = 100123,
    NonDiminishing = 100130,
}

export enum ExportContactField
{
    ContactId = 100010,
    Name = 100020,
    FirstName = 100021,
    MiddleName = 100022,
    PhysicalAddress1 = 100030,
    PhysicalAddress2 = 100031,
    PhysicalAddressSuburb = 100032,
    PhysicalAddressCity = 100033,
    PhysicalAddressPostCode = 100034,
    PostalAddress1 = 100040,
    PostalAddress2 = 100041,
    PostalAddressSuburb = 100042,
    PostalAddressCity = 100043,
    PostalAddressPostCode = 100044,
    Phone = 100050,
    Mobile = 100051,
    Email = 100055,
    LastSaleDate = 100060,
    LastSaleCaption = 100061,
    ContactType = 100070,
    CorrespondEmail = 100080,
    CorrespondBulkEmail = 100081,
    CorrespondPhone = 100082,
    CorrespondSMS = 100083,
    CorrespondMail = 100084,
}

export enum ExportCustomerSaleField
{
    SaleNo = 100010,
    DealershipName = 100020,
    SaleDate = 100030,
    VehicleYear = 100040,
    Make = 100050,
    Model = 100060,
    Variant = 100070,
    VIN = 100080,
    ChassisNo = 100090,
    EngineSize = 100100,
    Odometer = 100110,
    BodyStyle = 100120,
    Colour = 100130,
    FirstName = 100140,
    LastName = 100150,
    CompanyName = 100160,
    PhysicalAddress1 = 100170,
    PhysicalAddress2 = 100180,
    PhysicalSuburb = 100190,
    PhysicalCity = 100200,
    PhysicalPostCode = 100210,
    PostalAddress1 = 100220,
    PostalAddress2 = 100230,
    PostalSuburb = 100240,
    PostalCity = 100250,
    PostalPostCode = 100260,
    Phone = 100270,
    Mobile = 1000280,
    Email = 100290,
    DOB = 100300,
    CorrespondEmail = 100310,
    CorrespondBulkEmail = 100311,
    CorrespondPhone = 100312,
    CorrespondSMS = 100313,
    CorrespondMail = 100314,
}

export enum ExtenSpecKey
{
    None = 0,

    VehSupNichiboJapan = 100100,
    VehSupAutoterminal = 100200,
    VehSupIBCJapan = 100300,
    VehSupHeiwaAuto = 100400,
    VehSupSimonBeirne = 100410,
    VehSupEnhanceAuto = 100420,
    VehSupAutoPortal = 100430,
    VehSupNihonCars = 100440,
    VehSupNikkyoCars = 100450,
    VehSupAutohub = 100460,
    VehSupAutoSupply = 100470,
    VehSupDaveyJapan = 100480,
    VehSupGeneric = 100490,
    VehSupWorldNavi = 100500,
    VehSupDolphinShipping = 100600,
    VehSupVX = 100700,
    VehSupAutoFleetCapital = 100800,
    VehSupATNZ2000 = 100900,
    VehSupHVS = 101000,

    VehInfMotorWeb = 200100,

    VehServicePlanAutoServicePlan = 220100,
    VehTotal360 = 220200,
    VehBuyerScore = 220300,
    VehDriveText = 220400,

    VehWorkshopSAM = 230100,

    FinSupFinanceCentral = 302000,

    InsSupAutosure = 401000,
    InsSupProtecta = 402000,
    InsSupJanssen = 403000,
    InsSupMotorcentral = 404000,

    AccPackMYOB = 501000,
    AccPackXero = 502000,
    AccPackXeroAPI = 503000,
    AccPackXeroAPI2 = 504000,

    VehListMyWebsite = 600100,
    VehListMyWebsite2 = 600102,
    VehListMyWebsite3 = 600103,
    VehListAutobase = 600200,
    VehListDealerPoint = 600300,
    VehListDriveSouth = 600400,
    VehListTradeMe = 600500,
    VehListDealerzone = 600600,
    VehListNeedacar = 600700,
    VehListDriven = 600800,
    VehListILikeThat = 601500,
    VehListBayDriver = 601600,
    VehListHouGarden = 601800,
    VehListKwikz = 601900,
    VehListSimplify = 602000,
    VehListJustCar = 602100,
    VehListAutoInsiders = 602200,
    VehListPowerTrip = 602300,
    VehListUnixmo = 602400,
    VehListFacebook = 602600,
    VehListBetter = 602700,
    VehListDealerbase = 602800,
    VehListVX = 603000,
    VehListOnlyCars = 603100,
    VehListISqroll = 603200,
    VehListAutostock = 603300,
    VehListTheGlobe = 603400,
    VehListDealerStudio = 603500,
    VehImpAutoPlay = 700000
}

export enum ReportFileType
{
    Pdf = "Pdf",
    Csv = "Csv",
    Xml = "Xml",
    Jpeg = "Jpeg",
    Rdf = "Rdf",
}

export enum UserVariableClientType
{
    SmallScreenPwa = "SmallScreenPwa",
    LargeScreenPwa = "LargeScreenPwa",    
    Native = "Native",
    Embedded = "Embedded",
}

export enum ReportAction
{
    ExportAsPdf = "ExportAsPdf",
    ExportAsRtf = "ExportAsRtf",
    ExportAsXlsx = "ExportAsXlsx",
    ExportAsJpeg = "ExportAsJpeg",
    SendByEmail = "SendByEmail",
}